<template>
	<div class="espectaculo-compra-page" style="position: relative;">
		<div class="espectaculo-compra-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div class="header-row" v-else>
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<span>{{ espectaculo.nombre }}</span>
						</div>
					</div>
				</div>
				<div class="contador">
					<span class="tiempo-restante-label">Tiempo restante</span>
					<span class="tiempo-restante">
						{{ String(times[2].time).padStart(2, '0') }}:{{ String(times[3].time).padStart(2, '0') }}
					</span>
				</div>
			</div>
		</div>
		<div class="espectaculo-compra-main">
			<div class="container">
				<div class="espectaculo-compra-left">
					<h1>Información de los espectadores</h1>
					<p class="subtitle">Complete la información de sus tickets</p>
					<div class="tickets">
						<div class="ticket" :id="'tn' + (index + 1)" v-for="(ticket, index) in tickets" :key="ticket.id">
							<div class="ticket-overlay" v-if="ticket.recalculandoInfo">
								<clip-loader :loading="ticket.recalculandoInfo" color="#002F87" size="32px"></clip-loader>
								<vue-typed-js :strings="['Obteniendo categoría...']" :loop="true" :cursorChar="''" :typeSpeed="50" v-if="ticket.recalculandoInfo">
									<span class="typing"></span>
								</vue-typed-js>
							</div>
							<!-- <div class="row row-border-bottom">
								<span class="nro-ticket">Ticket #{{ index + 1 }}</span>
							</div> -->
							<!-- <span class="nro-ticket">Ticket #{{ index + 1 }}</span>
							<div class="row row-info">
								<span class="title">Datos personales</span>
							</div> -->
							<div class="row">
								<div class="row-group row-group-100">
									<span class="label">Preselección de persona</span>
									<multiselect v-model="ticket.preseleccionPersona" :options="preselecciones" @input="cambioPreseleccion(index)" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="(No utilizar preselección de persona)" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró preselección.</span>
										<span slot="noOptions">No hay preselecciones disponibles.</span>
									</multiselect>
								</div>
							</div>
							<div class="row">
								<div class="row-group">
									<span class="label">Tipo de documento</span>
									<multiselect v-model="ticket.tipoDocPersona" :options="tipoDocumentos" :disabled="ticket.esPreseleccion" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="row-group">
									<span class="label">Documento <info-icon tabindex="-1" content="Sin puntos ni guiones, ej. 12345678" v-tippy="{ placement : 'top'}"></info-icon></span>
									<input type="text" placeholder="Ej. 12345678" v-model="ticket.documentoPersona" @change="calcularCategoriaSocio(index)" :disabled="ticket.esPreseleccion">
								</div>
							</div>
							<div class="row">
								<div class="row-group">
									<span class="label">Nombre</span>
									<input type="text" v-model="ticket.nombrePersona" :disabled="ticket.esPreseleccion || ticket.tieneNombreApellido">
								</div>
								<div class="row-group">
									<span class="label">Apellido</span>
									<input type="text" v-model="ticket.apellidoPersona" :disabled="ticket.esPreseleccion || ticket.tieneNombreApellido">
								</div>
							</div>
							<div class="row" v-if="ticket.tienePin">
								<div class="row-group">
									<span class="label">PIN de Socio</span>
									<input type="text" @keypress="soloNumeros" maxlength="8" v-model="ticket.pin">
								</div>
							</div>
							<!-- <div class="row">
								<div class="row-group">
									<span class="label">Teléfono</span>
									<input type="text" v-model="ticket.telefonoPersona" @keypress="soloNumeros">
								</div>
								<div class="row-group">
									<span class="small-text">Por disposición del MSP, es obligatorio ingresar el número de teléfono del espectador</span>
								</div>
							</div> -->
							
							<div class="row row-complemento">
								<div class="row-group" v-for="(complemento, index) in datosComplementarios" :key="complemento.ComplementoId">
									<span class="label">{{ complemento.ComplementoNombre }}</span>
									<input type="text" v-model="ticket.datosComplementarios[index].Valor" v-if="complemento.ComplementoTipo !== 'O'">
									<multiselect v-else v-model="ticket.datosComplementarios[index].Valor" :options="datosComplementarios[index].Opciones" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontraron resultados.</span>
										<span slot="noOptions">No se encontraron resultados.</span>
									</multiselect>
								</div>
							</div>
							<div class="row row-aux">
								<div class="ticket-ubicacion">
									<div class="ticket-ubicacion-item">
										<span class="ticket-ubicacion-title">Tribuna</span>
										<span class="ticket-ubicacion-valor">{{ tribunaNombre }}</span>
									</div>
									<div class="ticket-ubicacion-item"  v-if="tribunaNombre !== sectorDescripcion">
										<span class="ticket-ubicacion-title">Sector</span>
										<span class="ticket-ubicacion-valor">{{ sectorDescripcion.replace('Sector ', '') }}</span>
									</div>
									<div class="ticket-ubicacion-item" v-if="sectorVentaTipo === 'N'">
										<span class="ticket-ubicacion-title">Fila</span>
										<span class="ticket-ubicacion-valor">{{ ticket.filaNombre.replace('Fila ', '') }}</span>
									</div>
									<div class="ticket-ubicacion-item" v-if="sectorVentaTipo === 'N'">
										<span class="ticket-ubicacion-title">Asiento</span>
										<span class="ticket-ubicacion-valor">{{ ticket.asientoNombre.replace('Asiento ', '') }}</span>
									</div>
								</div>
								<div class="ticket-categoria">
									<span class="label">Categoría</span>
									<span class="campo" v-if="ticket.documentoPersona.trim()">{{ ticket.catSocioPersona }}</span>
									<span class="campo campo-small" v-else>Ingresa documento</span>
								</div>
							</div>
						</div>
					</div>
					<p style="margin-bottom: 15px;" class="full-info-title">Información del espectáculo</p>
					<div class="info-espectaculo full-info-main">
						<div class="competencia" v-if="espectaculo.mostrarCompetencia">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
						</div>
						<div class="fecha" v-if="espectaculo.mostrarFecha">
							<span class="fecha-title">Fecha</span>
							<div class="fecha-content">
								<div class="fecha-texto">
									<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
									<p>{{ espectaculo.fechaEscrita }}</p>
								</div>
								<div class="fecha-hora">
									{{ espectaculo.hora }}
								</div>
							</div>
						</div>
						<div class="lugar" v-if="espectaculo.mostrarEscenario">
							<span class="lugar-title">Lugar</span>
							<div class="lugar-content">
								<div class="lugar-content-left">
									<div class="lugar-info">
										<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
										<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
									</div>
									<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre" v-if="espectaculo.escenarioLogo">
								</div>
								<div class="ver-mapa" content="Ver ubicación" tabindex="-1" v-tippy="{ placement : 'bottom'}">
									<a :href="espectaculo.escenarioMapaURL" tabindex="-1" target="_blank"><map-icon></map-icon></a>
								</div>
							</div>
						</div>
						<div class="descripcion">
							<span class="descripcion-title">Descripción</span>
							<!-- <span class="descripcion-content">{{ espectaculo.descripcion }}</span> -->
							<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
						</div>
					</div>
				</div>
				<div class="espectaculo-compra-right">
					<div class="resumen-header">
						<h1>Resumen</h1>
						<p>Detalles de tu compra / canje</p>
					</div>
					<div class="resumen-footer">
						<p><b>Aclaración:</b> El precio de cada ticket se basa en la categoría del socio, la cual es calculada a partir del documento.</p>
					</div>
					<div class="resumen-listado">
						<div class="resumen-ticket" v-for="(ticket, index) in tickets" :key="ticket.id">
							<div class="resumen-ticket-left">
								<span class="ticket-nro">Ticket #{{ index + 1 }}</span>
								<span v-if="ticket.nombrePersona && ticket.apellidoPersona && ticket.documentoPersona">{{ ticket.nombrePersona }} {{ ticket.apellidoPersona }} &bull; {{ ticket.documentoPersona }}</span>
								<span v-if="ticket.nombrePersona && ticket.apellidoPersona && ticket.documentoPersona">{{ ticket.catSocioPersona }}</span>
								<span v-else>Completa la información de la persona</span>
							</div>
							<div class="resumen-ticket-right" v-if="ticket.nombrePersona && ticket.apellidoPersona && ticket.documentoPersona && !isNaN(ticket.precioTicket)">{{ monedaSimbolo }} {{ ticket.precioTicket }}</div>
							<div class="resumen-ticket-right" v-else>-</div>
						</div>
						<div class="resumen-total">
							<span class="label">
								Total a pagar
							</span>
							<span class="total" v-if="datosCompletos && !isNaN(total)">
								{{ monedaSimbolo }} {{ total }}
							</span>
							<span class="total" v-else>-</span>
						</div>
					</div>
					<div class="acciones-aside">
						<div class="acciones-aside-botones">
							<!-- <button class="cancelar-reserva" @click="cancelarReservaModal">Cancelar transacción</button> -->
							<!-- <button @click="promptPagar" v-if="total > 0" :disabled="!datosCompletos">Pagar tickets<credit-card-icon></credit-card-icon></button> -->
							<!-- <div class="button-pago" v-if="total > 0 && datosCompletos"></div> -->
							<button @click="pagarTickets" class="button-pago" v-if="total > 0 && datosCompletos && !pagando">Pagar {{ monedaSimbolo }}{{ total }}</button>
							<button @click="canjear" :disabled="!datosCompletos" v-else-if="datosCompletos && total === 0">Canjear tickets <img src="../../assets/ticket.svg" alt="Comprar entrada"></button>
							<button disabled="disabled" v-else-if="pagando">Pagando</button>
							<button disabled="disabled" v-else>Completa los datos</button>
						</div>
					</div>
					<div class="cancelar-transaccion" @click="cancelarReservaModal" v-if="!pagando">
						Cancelar transacción
					</div>
					<div class="medio-pago" v-if="espectaculo.medioPagoId > 0 && espectaculo.medioPagoIconoB64">
						<span>Pago seguro a través de</span>
						<img :src="espectaculo.medioPagoIconoB64" :alt="espectaculo.medioPagoNombre" v-if="espectaculo.medioPagoIconoB64" />
						<span v-if="espectaculo.medioPagoCuotas > 1" style="margin-left: 5px;">hasta en {{ espectaculo.medioPagoCuotas }} cuotas.</span>
					</div>
					<div class="spinner-canje" v-if="canjeando">
						<clip-loader :loading="canjeando" color="#11244d" size="48px"></clip-loader>
						<vue-typed-js :strings="['Emitiendo ticket...', 'Generando PDF...']" :loop="true" :cursorChar="''" :typeSpeed="50" v-if="canjeando">
							<span class="typing"></span>
						</vue-typed-js>
					</div>
					<div class="form-overlay" v-if="canjeando"></div>
				</div>
				<p style="margin-bottom: 10px;" class="mobile-info-title">Información del espectáculo</p>
				<div class="info-espectaculo mobile-info-main">
					<div class="competencia" v-if="espectaculo.mostrarCompetencia">
						<div class="competencia-info">
							<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
							<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
						</div>
						<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
					</div>
					<div class="fecha" v-if="espectaculo.mostrarFecha">
						<span class="fecha-title">Fecha</span>
						<div class="fecha-content">
							<div class="fecha-texto">
								<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
								<p>{{ espectaculo.fechaEscrita }}</p>
							</div>
							<div class="fecha-hora">
								{{ espectaculo.hora }}
							</div>
						</div>
					</div>
					<div class="lugar" v-if="espectaculo.mostrarEscenario">
						<span class="lugar-title">Lugar</span>
						<div class="lugar-content">
							<div class="lugar-content-left">
								<div class="lugar-info">
									<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
									<span class="lugar-direccion">{{ espectaculo.escenarioDireccion }}</span>
								</div>
								<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre" v-if="espectaculo.escenarioLogo">
							</div>
							<div class="ver-mapa" content="Ver ubicación" tabindex="-1" v-tippy="{ placement : 'bottom'}">
								<a :href="espectaculo.escenarioMapaURL" tabindex="-1" target="_blank"><map-icon></map-icon></a>
							</div>
						</div>
					</div>
					<div class="descripcion">
						<span class="descripcion-title">Descripción</span>
						<!-- <span class="descripcion-content">{{ espectaculo.descripcion }}</span> -->
						<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
					</div>
				</div>
			</div>
		</div>
		<modal class="promptCancelarReserva" name="promptCancelarReserva">
			<h2>¿Cancelar transacción?</h2>
			<p>Es posible que los lugares elegidos no estén disponibles en un futuro</p>
			<div>
				<button @click="cerrarModal" class="aux">No, quedarme</button>
				<button @click="cancelarReserva">Si, cancelar</button>
			</div>
		</modal>
		<modal class="prompt-pago" name="promptPago" @closed="promptPagoCerrado" @opened="promptPagoAbierto" :scrollable="true" height="auto">
			<div class="prompt-pago-content">
				<div class="card-form-wrapper">
					<div class="card-form">
						<div class="card-list">
							<div class="card-item" v-bind:class="{ '-active' : isCardFlipped }">
								<div class="card-item__side -front">
								<div class="card-item__focus" v-bind:class="{'-active' : focusElementStyle }" v-bind:style="focusElementStyle" ref="focusElement"></div>
								<div class="card-item__cover">
									<img src="../../assets/cards/card-front.jpg" class="card-item__bg">
								</div>
								
								<div class="card-item__wrapper">
									<div class="card-item__top">
									<img src="../../assets/cards/chip.png" class="card-item__chip">
									<div class="card-item__type">
										<transition name="slide-fade-up">
											<img :src="require(`@/assets/cards/${paymentTypeId}.png`)" v-if="paymentTypeId !== ''" v-bind:key="paymentTypeId" :alt="paymentTypeId" class="card-item__typeImg">
											<img src="../../assets/cards/tarjeta.png" v-else alt="" class="card-item__typeImg">
											<!-- <img :src="'../../assets/cards/' + getCardType + '.png'" v-if="getCardType" v-bind:key="getCardType" :alt="getCardType" class="card-item__typeImg"> -->
										</transition>
									</div>
									</div>
									<label for="cardNumber" class="card-item__number" ref="cardNumber">
										<template v-if="paymentTypeId === 'diners'">
											<span v-for="(n, $index) in dinersCardMask" :key="$index">
												<transition name="slide-fade-up">
													<div class="card-item__numberItem" v-if="$index > 4 && $index < 14 && form.cardNumber.length > $index && n.trim() !== ''">*</div>
													<div class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }" :key="$index" v-else-if="form.cardNumber.length > $index">{{form.cardNumber[$index]}}</div>
													<div class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }" v-else :key="$index + 1">{{n}}</div>
												</transition>
											</span>
										</template>
										<template v-else>
											<span v-for="(n, $index) in otherCardMask" :key="$index">
											<transition name="slide-fade-up">
												<div class="card-item__numberItem" v-if="$index > 4 && $index < 15 && form.cardNumber.length > $index && n.trim() !== ''">*</div>
												<div class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }" :key="$index" v-else-if="form.cardNumber.length > $index">{{form.cardNumber[$index]}}</div>
												<div class="card-item__numberItem" :class="{ '-active' : n.trim() === '' }" :key="$index + 1" v-else>{{n}}</div>
											</transition>
											</span>
										</template>
									</label>
									<div class="card-item__content">
									<label for="cardholderName" class="card-item__info" ref="cardholderName">
										<div class="card-item__holder">Nombre del titular</div>
										<transition name="slide-fade-up">
										<div class="card-item__name" v-if="form.cardholderName.length" key="1">
											<transition-group name="slide-fade-right">
											<span class="card-item__nameItem" v-for="(n, $index) in form.cardholderName.replace(/\s\s+/g, ' ')" v-bind:key="$index + 1"><div v-if="$index === $index">{{n}}</div></span>
											</transition-group>
										</div>
										<div class="card-item__name" v-else key="2">Prudencio Reyes</div>
										</transition>
									</label>
									<div class="card-item__date" ref="cardDate">
										<label for="cardMonth" class="card-item__dateTitle">Expira</label>
										<label for="cardMonth" class="card-item__dateItem">
										<transition name="slide-fade-up">
											<span v-if="form.cardExpirationMonth" v-bind:key="form.cardExpirationMonth">{{form.cardExpirationMonth}}</span>
											<span v-else key="2">MM</span>
										</transition>
										</label>
										/
										<label for="cardYear" class="card-item__dateItem">
										<transition name="slide-fade-up">
											<span v-if="form.cardExpirationYear" v-bind:key="form.cardExpirationYear">{{String(form.cardExpirationYear).slice(2,4)}}</span>
											<span v-else key="2">AA</span>
										</transition>
										</label>
									</div>
									</div>
								</div>
								</div>
								<div class="card-item__side -back">
								<div class="card-item__cover">
									<img src="../../assets/cards/card-back.jpg" class="card-item__bg">
								</div>
								<div class="card-item__band"></div>
								<div class="card-item__cvv">
									<div class="card-item__cvvTitle">CVV</div>
									<div class="card-item__cvvBand">
										<span v-for="(n, $index) in form.securityCode" :key="$index">*</span>
									</div>
									<div class="card-item__type">
										<img :src="require(`@/assets/cards/${paymentTypeId}.png`)" v-if="paymentTypeId !== ''" v-bind:key="paymentTypeId" :alt="paymentTypeId" class="card-item__typeImg">
										<img src="../../assets/cards/tarjeta.png" v-else alt="" class="card-item__typeImg">
										<!-- <img :src="'../../assets/cards/' + getCardType + '.png'" v-if="getCardType" :key="getCardType" :alt="getCardType" class="card-item__typeImg"> -->
									</div>
								</div>
								</div>
							</div>
						</div>
						<div class="card-form__inner">
							<div class="tarjetas-disponibles">
								<div class="tarjeta">
									<img src="../../assets/cards/visa-color.png" alt="Visa">
								</div>
								<div class="tarjeta">
									<img class="h-18" src="../../assets/cards/master-color.png" alt="Visa">
								</div>
								<div class="tarjeta">
									<img src="../../assets/cards/oca-color.png" alt="Visa">
								</div>
								<div class="tarjeta">
									<img src="../../assets/cards/lider-color.png" alt="Visa">
								</div>
								<div class="tarjeta">
									<img class="h-18" src="../../assets/cards/diners-color.png" alt="Visa">
								</div>
							</div>
							<div class="input-rows">
								<div class="input-row">
									<div class="input-group">
										<label for="formEmail" class="card-input__label">Correo electrónico</label>
										<input v-model="form.email" id="formEmail" class="card-input__input" type="email" @blur="formatoEmail()" :focus="focusInput" :disabled="pagando ? 'disabled': null"/>
									</div>
								</div>
								<div class="input-row">
									<div class="input-group">
										<label for="cardholderName" class="card-input__label">Nombre del titular de la tarjeta</label>
										<input
											v-model="form.cardholderName"
											id="cardholderName"
											type="text"
											class="card-input__input"
											:disabled="pagando ? 'disabled': null"
											v-on:focus="focusInput"
											v-on:blur="blurInput"
											data-ref="cardholderName"
											autocomplete="off" />
									</div>
								</div>
								<div class="input-row">
									<div class="input-group input-group-33">
										<label for="docType" class="card-input__label">Tipo de documento</label>
										<select v-model="form.docType" id="docType" data-checkout="docType" class="card-input__input -select" :disabled="pagando ? 'disabled': null">
											<option value="CI">CI</option>
											<option value="Otro">Otro</option>
										</select>
									</div>
									<div class="input-group input-group-66">
										<label for="docNumber" class="card-input__label">Número de documento</label>
										<input v-model="docNumber" id="docNumber" @blur="formatoDoc" type="text" placeholder="Sin puntos ni guiones" class="card-input__input" :disabled="pagando ? 'disabled': null"/>
									</div>
								</div>
								<div class="input-row">
									<div class="input-group">
										<label for="cardNumber" class="card-input__label">Número de tarjeta</label>
										<input
											type="text"
											id="cardNumber"
											class="card-input__input"
											v-on:focus="focusInput"
											v-model="form.cardNumber"
											v-mask="generateCardNumberMask"
											@keyup="guessingPaymentMethod()"
											@blur="guessingPaymentMethod()"
											data-ref="cardNumber"
											onselectstart="return false" onpaste="return false" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false"
											autocomplete=off 
											:disabled="pagando ? 'disabled': null"/>
									</div>
								</div>
								<div class="input-row">
									<div class="input-group input-group-33">
										<label for="cardMonth" class="card-input__label">Fecha de expiración</label>
										<select class="card-input__input -select" id="cardMonth" v-model="form.cardExpirationMonth" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate" :disabled="pagando ? 'disabled': null">
											<option value="" disabled selected>Mes</option>
											<!-- <option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth" v-bind:key="n">{{n < 10 ? '0' + n : n}}</option> -->
											<option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth" v-bind:key="n">{{ n }}</option>
										</select>
									</div>
									<div class="input-group input-group-33">
										<select class="card-input__input -select" id="cardYear" v-model="form.cardExpirationYear" v-on:focus="focusInput" v-on:blur="blurInput" data-ref="cardDate" :disabled="pagando ? 'disabled': null">
											<option value="" disabled selected>Año</option>
											<option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">{{$index + minCardYear}}</option>
										</select>
									</div>
									<div class="input-group input-group-33">
										<label for="cardCvv" class="card-input__label">CVV</label>
										<input
											type="text"
											class="card-input__input"
											id="cardCvv"
											v-mask="'####'"
											maxlength="4"
											v-model="form.securityCode"
											v-on:focus="flipCard(true)"
											v-on:blur="flipCard(false)"
											placeholder="000"
											onselectstart="return false"
											onpaste="return false"
											onCopy="return false"
											onCut="return false"
											onDrag="return false"
											onDrop="return false"
											autocomplete="off"
											:disabled="pagando ? 'disabled': null">
									</div>
								</div>
								<div class="promptPago-footer">
									<span v-if="errorPago" class="error-msg">{{errorPago}}</span>
									<div class="promptPago-botones">
										<button @click="cerrarPromptPago()" class="card-form__button promptPago-cerrar">Cancelar</button>
										<button @click="pagar()" :disabled="pagando ? 'disabled': null" class="card-form__button">Pagar {{ monedaSimbolo }}{{ total }}</button>
									</div>
								</div>
								<div class="spinner-pago" v-if="pagando">
									<clip-loader :loading="pagando" color="#11244d" size="48px"></clip-loader>
									<span>Estamos procesando su pago...</span>
								</div>
								<div class="form-overlay" v-if="pagando"></div>
							</div>
							<div class="promptPago-mp">
								<div class="promptPago-mp-left">
									<img src="../../assets/lock.svg" alt="Transacción segura">
									<span>Su transacción está protegida con cifrado SSL</span>
								</div>
								<!-- <div class="promptPago-mp-right">
									<img src="../../assets/cards/mercadopago.png" alt="Mercado Pago">
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import { MapIcon, InfoIcon } from 'vue-feather-icons'
	// import s_pagar from '../mercadopago/s_pagar'
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data() {
			return {
				// Mercadopago
				preferenceId: null,
				initPoint: null,
				usuario: null,
				// ***********
				fechaActual: new Date(),
				usuarioId: localStorage.getItem('usuario_id'),
				transaccionId: 0,
				transaccionFechafin: localStorage.getItem('trn_end_time') ? new Date(localStorage.getItem('trn_end_time')) : new Date(),
				espectaculo: {
					id: null,
					nombre: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioDireccion: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					descripcion: '',
					mostrarCompetencia: false,
					mostrarFecha: false,
					mostrarEscenario: false,
					medioPagoId: null,
					medioPagoNombre: '',
					medioPagoIconoB64: '',
					medioPagoCuotas: 1
				},
				cantidadTickets: 1,
				tickets: [],
				tribunaId: '',
				tribunaNombre: '',
				sectorCod: '',
				sectorVentaTipo: '',
				sectorDescripcion: '',
				hayError: false,
				errorMsg: '',
				monedaId: 1,
				monedaSimbolo: '',
				preselecciones: [],
				tipoDocumentos: [],
				tipoDocumentoCI: null,
				asientosElegidos: [{filaId: 0, filaNombre: '', asientoId: 0, asientoNombre: ''}],
				categoriasSocios: [],
				sectorEsVisitante: false,
				canjeando: false,
				startTime: new Date(),
				progress: 100,
				timeinterval: undefined,
				times: [
					{ id: 0, text: "Días", time: 0 },
					{ id: 1, text: "Horas", time: 0 },
					{ id: 2, text: "Minutos", time: 14 },
					{ id: 3, text: "Segundos", time: 59 }
				],
				paymentTypeId: '',
				form: {
					email: '',
					cardNumber: '',
					securityCode: '',
					cardExpirationMonth: '',
					cardExpirationYear: '',
					cardholderName: '',
					docType: 'CI',
					docNumber: ''
				},
				// form: {
				// 	email: 'test_user_94394262@testuser.com',
				// 	cardNumber: '4509 9535 6623 3704',
				// 	securityCode: '123',
				// 	cardExpirationMonth: 11,
				// 	cardExpirationYear: 2025,
				// 	cardholderName: 'Juan Manuel Campón',
				// 	docType: 'CI',
				// 	docNumber: 47735002
				// },
				// docNumber: null,
				// docNumber: '4.773.500-2',
				docNumber: '1.234.567-8',
				paymentType: null,
				pagando: false,
				errorPago: null,

				/* Formulario Tarjeta */
				cardNumber: '',
				minCardYear: new Date().getFullYear(),
				dinersCardMask: '#### ###### ####',
				otherCardMask: '#### #### #### ####',
				isCardFlipped: false,
				focusElementStyle: null,
				isInputFocused: false,
				isPersonaValidarOk: false,

				/* Datos complementarios */
				datosComplementarios: []
			}
		},
		components: {
			MapIcon,
			InfoIcon,
			ClipLoader
		},
		async mounted() {
			this.$store.dispatch('cargando', true);

			// if(localStorage.getItem('isPagando') === 'SI'){
			// 	this.$store.dispatch('mostrarError', 'Transacción cancelada. Debe realizar el proceso nuevamente')
			// 	this.$router.push({ name: 'home' })
			// }

			await this.datosUsuario();

			// Obtengo información de los tickets de Vuex
			if(this.ticketsPropiedades === null || this.ticketsPropiedades === undefined){
				this.$router.push({ name: 'home' });
			} else {
				if(Number(this.$route.params.espectaculoId) !== this.ticketsPropiedades.espectaculoId){
					this.$router.push({ name: 'home' })
				} else {
					this.tribunaId = this.ticketsPropiedades.tribunaId;
					this.tribunaNombre = this.ticketsPropiedades.tribunaNombre;
					this.sectorCod = this.ticketsPropiedades.sectorCod;
					this.sectorDescripcion = this.ticketsPropiedades.sectorDescripcion;
					this.cantidadTickets = this.ticketsPropiedades.cantidadTickets;
					this.asientosElegidos = this.ticketsPropiedades.asientosElegidos;
					this.sectorVentaTipo = this.ticketsPropiedades.sectorVentaTipo;
					this.sectorEsVisitante = this.ticketsPropiedades.sectorEsVisitante;
					this.categoriasSocios = this.ticketsPropiedades.categoriasSocios;
					this.transaccionId = this.ticketsPropiedades.transaccionId;
				}
			}

			await this.tiposDocumentos();

			// var catSocioIdMax, catSocioNombreMax;
			// var catSocioPrecioMax = Math.max.apply(Math, this.categoriasSocios.map(function(o) { return o.precioOriginal; }))

			// for(var l=0; l<this.categoriasSocios.length; l++){
			// 	if(Number(this.categoriasSocios[l].precioOriginal) === Number(catSocioPrecioMax)){
			// 		catSocioIdMax = this.categoriasSocios[l].id
			// 		catSocioNombreMax = this.categoriasSocios[l].nombre
			// 	}
			// }

			let pre = {
				personaId: 0, 
				personaPreText: null,
				personaNombre: null,
				personaApellido: null,
				personaDocumentoTipo: null,
				personaDocumento: null,
				personaSocioNro: null,
				// personaSocioCategoria: null,
				personaDocumentoTipoAbr: null,
				descripcion: '(No utilizar preselección de persona)'
			}

			var ticket = {}
			for(var n=0; n<this.cantidadTickets; n++){
				ticket = {
					id: n,
					nombrePersona: '',
					apellidoPersona: '',
					tipoDocPersona: this.tipoDocumentoCI,
					documentoPersona: '',
					telefonoPersona: '',
					nroSocioPersona: '',
					catSocioPersonaId: null,
					catSocioPersona: null,
					precioTicket: null,
					guardarInformacionPersona: false,
					esPreseleccion: false,
					preseleccionPersona: pre,
					filaId: this.asientosElegidos[n].filaId,
					filaNombre: this.asientosElegidos[n].filaNombre,
					asientoId: this.asientosElegidos[n].asientoId,
					asientoNombre: this.asientosElegidos[n].asientoNombre,
					nroButacaPersona: '',
					recalculandoInfo: false,
					datosComplementarios: [],
					tienePin: false,
					pin: '',
					tieneNombreApellido: false
				}
				this.tickets.push(ticket);
			}

			await this.cargoPreselecciones();
			await this.cargoEspectaculo();
			await this.cargoDatosComplementarios();

			// await this.crearOrdenDePago();

			this.$store.dispatch('cargando', false);
		},
		computed: {
			expiroTiempo: function(){
				if(this.times[0].time <= 0 && this.times[1].time <= 0 && this.times[2].time <= 0 && this.times[3].time <= 0){
					return true
				} else {
					return false
				}
			},
			ticketsPropiedades: function(){
				return this.$store.state.ticketsPropiedades
			},
			total: function(){
				let sum = 0;
				for(let i = 0; i < this.tickets.length; i++){
					sum += parseFloat(this.tickets[i].precioTicket);
				}

				return sum;
			},
			datosCompletos: function(){
				var estanCompletos = true
				for(var i=0; i<this.tickets.length; i++){
					// if(this.tickets[i].nombrePersona.trim().length <= 2 || this.tickets[i].apellidoPersona.trim().length <= 2 || this.tickets[i].documentoPersona.trim().length <= 3 || (this.tickets[i].telefonoPersona.length < 8 || this.tickets[i].telefonoPersona.length > 20)){
					if(this.tickets[i].nombrePersona.trim().length <= 2 || this.tickets[i].apellidoPersona.trim().length <= 2 || this.tickets[i].documentoPersona.trim().length <= 3 || (this.tickets[i].tienePin === true && this.tickets[i].pin.length < 4)){
						estanCompletos = false
						break;
					}
				}

				return estanCompletos
			},
			bin: function() {
				return this.form.cardNumber && this.form.cardNumber.split('').map(digito => {
					return Number(digito) > 0 || digito === '0' ? digito: ''
				}).join('').substring(0,6)
			},
			generateCardNumberMask () {
				// Si utiliza American Express o Diners
				return this.paymentTypeId === "diners" ? this.dinersCardMask : this.otherCardMask;
			},
			minCardMonth () {
				if (this.form.cardExpirationYear === this.minCardYear) return new Date().getMonth() + 1;
				return 1;
			}
		},
		watch: {
			expiroTiempo: function(){
				if(this.expiroTiempo === true){
					this.expiracionTiempo();
				}
			},
			cardYear () {
				if (this.form.cardExpirationMonth < this.minCardMonth) {
					this.form.cardExpirationMonth = "";
				}
			},
			preferenceId: function(){
				const script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = 'https://sdk.mercadopago.com/js/v2';
				script.addEventListener('load', ()=> {
					const mp = new MercadoPago(process.env.VUE_APP_MERCADOPAGO_PUBLIC_KEY, {
						locale: 'es-UY'
					});

					// Inicializa el checkout
					mp.checkout({
						preference: {
							id: this.preferenceId
						}
					});
				});
				document.body.appendChild(script);
			}
		},
		methods: {
			async datosUsuario(){
				try {
					let response = await axios.post('/WSUsuarioPago', { UsuarioId: this.usuarioId }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} })

					if(response.data.ErrorCod === 0){
						this.usuario = response.data.SDTUsuario
					} else {
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async crearOrdenDePagoMP(){
				try {
					let tit = '';
					let dsc = '';

					if(this.cantidadTickets > 1){
						tit = "Entradas " + this.espectaculo.nombre.trim()
						dsc = String(this.cantidadTickets) + " entradas para " + this.espectaculo.nombre.trim() + ". Tribuna: " + this.tribunaNombre.trim()
					} else {
						tit = "Entrada " + this.espectaculo.nombre.trim()
						dsc = "Entrada para " + this.espectaculo.nombre.trim() + ". Tribuna: " + this.tribunaNombre.trim()
					}

					let trnFechaFin = this.transaccionFechafin
					// console.log('TRNFECHAFIN =====');
					// console.log(trnFechaFin);
					trnFechaFin.setTime(trnFechaFin.getTime() - (90 *  1000)); // Le resto 90 segundos, para evitar problemas con fechas (demonio cancelación)
					// console.log('TRNFECHAFIN DESPUES DE RESTARLE SEGUNDOS =====');
					// console.log(trnFechaFin);
					let fchFin = trnFechaFin.getFullYear() + "-" + ('0' + (trnFechaFin.getMonth()+1)).slice(-2) + "-" + ('0' + trnFechaFin.getDate()).slice(-2) + "T" + String(trnFechaFin.getHours()).padStart(2, '0') + ":" + String(trnFechaFin.getMinutes()).padStart(2, '0') + ":" + String(trnFechaFin.getSeconds()).padStart(2, '0') + ".000-03:00"
					// console.log('FCHFIN ENVIADA A MP =====');
					// console.log(fchFin);
					// let cntCuotas = 1;

					// let currency = 'UYU';
					// if(Number(this.monedaId) === 1){
					// 	currency = 'UYU';
					// }

					let preference = {
						binary_mode: true,
						items: [
							{
								id: String(this.espectaculo.id) + '-' + String(this.tribunaId) + '-' + String(this.sectorCod),
								title: tit,
								currency_id: this.monedaId,
								description: dsc,
								category_id: "tickets",
								quantity: 1,
								unit_price: this.total
							}
						],
						payer: {
							name: this.usuario.UsuarioPersonaNombre,
							surname: this.usuario.UsuarioPersonaApellido,
							email: this.usuario.UsuarioEmail,
							// phone: {
							// 	area_code: "",
							// 	number: this.usuario.UsuarioPersonaTelefono
							// },
							identification: {
								type: Number(this.usuario.UsuarioPersonaDocumentoTipoId),
								number: this.usuario.UsuarioPersonaDocumento
							}
						},
						// back_urls: {
						// 	success: "https://ticketing.nacional.uy/pago-exitoso",
						// 	failure: "https://ticketing.nacional.uy"
						// },
						back_urls: {
							success: "",
							failure: ""
						},
						auto_return: "approved",
						payment_methods: {
							// excluded_payment_methods: [
							// 	{}
							// ],
							excluded_payment_types: [
								{
									id: "ticket"
								}
							],
							installments: Number(this.espectaculo.medioPagoCuotas)
						},
						notification_url: process.env.VUE_APP_URL_NODE_MERCADOPAGO + "/ipn?source_news=ipn",
						// statement_descriptor: "Nacional Ticketing - " + this.espectaculo.nombre.trim(),
						external_reference: String(this.espectaculo.id) + "-" + String(this.transaccionId),
						expires: true,
						expiration_date_from: "",
						expiration_date_to: fchFin.trim(),
					};

					let response = await axios.post(process.env.VUE_APP_URL_NODE_MERCADOPAGO + '/create_preference', { preference: preference })

					this.preferenceId = response.data.preferenceId
					this.initPoint = response.data.initPoint
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async crearOrdenDePagoPP(){
				try {
					let tit = '';
					let dsc = '';

					if(this.cantidadTickets > 1){
						tit = "Entradas " + this.espectaculo.nombre.trim()
						dsc = String(this.cantidadTickets) + " entradas para " + this.espectaculo.nombre.trim() + ". Tribuna: " + this.tribunaNombre.trim()
					} else {
						tit = "Entrada " + this.espectaculo.nombre.trim()
						dsc = "Entrada para " + this.espectaculo.nombre.trim() + ". Tribuna: " + this.tribunaNombre.trim()
					}

					let order = {
						intent: 'CAPTURE',
						purchase_units: [
							{
								reference_id: String(this.espectaculo.id) + "-" + String(this.transaccionId), // Código de referencia de nuestro sistema (espectaculoId-transaccionId)
								amount: {
									currency_code: 'USD', // Código de moneda
									value: this.total, // Monto
								},
								description: dsc
							}
						],
						application_context: {
							brand_name: 'Nacional Ticketing',
							landing_page: 'NO_PREFERENCE',
							user_action: 'PAY_NOW',
							return_url: '',
							cancel_url: ''
						}
					};

					let response = await axios.post(process.env.VUE_APP_URL_NODE_PAYPAL + '/create-order', { order })

					this.initPoint = response.data.links[1].href;
					console.log(response)
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async pagarTickets(){
				this.pagando = true;
				this.$store.dispatch('cargando', true);

				await this.validacionDatos();

				if(this.total > 0){
					if(this.hayError === false){
						await this.personaValidar();

						if(this.isPersonaValidarOk === true){
							if(Number(this.espectaculo.medioPagoId) === 2){
								await this.crearOrdenDePagoPP();
							} else {
								await this.crearOrdenDePagoMP();
							}

							if(this.initPoint){
								let SDTPersona = []

								for(let m=0; m<this.tickets.length; m++){
									let SDTPersonaItem = {
										PersonaNombre: this.tickets[m].nombrePersona.trim(),
										PersonaApellido: this.tickets[m].apellidoPersona.trim(),
										PersonaDocumentoTipoId: Number(this.tickets[m].tipoDocPersona.valor),
										PersonaDocumento: this.tickets[m].documentoPersona,
										PersonaSocioNro: this.tickets[m].nroSocioPersona,
										PersonaButacaNro: this.tickets[m].nroButacaPersona,
										PersonaSocioCategoriaid: Number(this.tickets[m].catSocioPersonaId),
										// PersonaTelefono: this.tickets[m].telefonoPersona
										PersonaTelefono: ''
									}
									SDTPersona.push(SDTPersonaItem);
								}

								// Emitir ticket
								let SDTTicket;
								let TicketItems = [];
								let TicketItem;
								let ticketTipo;
								let TicketComplemento;
								let SDTComplementosValores = [];
								let SDTComplementosValoresJSON = '';

								for(let n=0; n<this.tickets.length; n++){
									if(Number(this.tickets[n].precioTicket) === 0){
										ticketTipo = 'C'
									} else {
										ticketTipo = 'V'
									}

									TicketItem = {
										Id: Number(n + 1),
										TicketMonto: this.tickets[n].precioTicket,
										TicketTipo: ticketTipo,
										TribunaId: this.tribunaId,
										SectorCod: this.sectorCod,
										FilaId: this.tickets[n].filaId,
										AsientoId: this.tickets[n].asientoId,
										PersonaNombre: this.tickets[n].nombrePersona.trim(),
										PersonaApellido: this.tickets[n].apellidoPersona.trim(),
										PersonaDocumentoTipoId: this.tickets[n].tipoDocPersona.valor,
										PersonaDocumento: this.tickets[n].documentoPersona,
										// PersonaTelefono: this.tickets[n].telefonoPersona,
										PersonaTelefono: '',
										PersonaSocioNro: this.tickets[n].nroSocioPersona,
										PersonaButacaNro: this.tickets[n].nroButacaPersona,
										PersonaSocioCategoriaid: Number(this.tickets[n].catSocioPersonaId),
										TicketButacaNro: '',
										TicketFilialId: 0,
										TicketPaisId: 0,
										TicketCiudadNombre: '',
										TicketPIN: this.tickets[n].tienePin ? this.tickets[n].pin.trim() : ''
									}
									TicketItems.push(TicketItem);

									for(let s=0; s<this.tickets[n].datosComplementarios.length; s++){
										let value = null;

										if(this.datosComplementarios[s].ComplementoTipo === 'O'){
											if(this.tickets[n].datosComplementarios[s].Valor){
												value = this.tickets[n].datosComplementarios[s].Valor.valor;
											}
										} else {
											if(this.tickets[n].datosComplementarios[s].Valor && this.tickets[n].datosComplementarios[s].Valor.trim() !== ''){
												value = this.tickets[n].datosComplementarios[s].Valor;
											}
										}

										if(value){
											TicketComplemento = {
												Index: Number(n + 1),
												ComplementoId: this.tickets[n].datosComplementarios[s].ComplementoId,
												ComplementoRegistroValor: value
											}

											SDTComplementosValores.push(TicketComplemento);
										}
									}
								}

								SDTComplementosValoresJSON = JSON.stringify(SDTComplementosValores);

								SDTTicket = { EspectaculoId: Number(this.$route.params.espectaculoId), TransaccionId: this.transaccionId, Ticket: TicketItems}

								// Llamo a WSTicketPago
								try {
									let response = await axios.post('/WSTicketPago', {
										UsuarioId: this.usuarioId,
										SDTTicketJSON: JSON.stringify(SDTTicket),
										SDTPersonaJSON: JSON.stringify(SDTPersona),
										MonedaId: Number(this.monedaId),
										PagoMonto: this.total,
										SDTComplementosValoresJSON: SDTComplementosValoresJSON,
										TransaccionPreferenciaId: this.preferenceId.trim()
									}, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`}});

									if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11 || response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
										this.$store.dispatch('cargando', false);
										this.$store.dispatch('limpiarTicketsPropiedades');
										this.$store.dispatch('limpiarTrnFechaFin');
										this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
									} else {
										if(response.data.ErrorCod === 0){
											// Ticket emitido correctamente
											this.$store.dispatch('cargando', false);
											this.$store.dispatch('limpiarTicketsPropiedades');
											this.$store.dispatch('limpiarTrnFechaFin');

											// localStorage.setItem('isPagando', 'SI');
											window.open(this.initPoint, '_self');
										} else {
											if(response.data.ErrorCod === 30 || response.data.ErrorCod === 40 || response.data.ErrorCod === 110 || response.data.ErrorCod === 111 || response.data.ErrorCod === 112){
												this.$store.dispatch('cargando', false);
												this.$store.dispatch('limpiarTicketsPropiedades');
												this.$store.dispatch('limpiarTrnFechaFin');
												this.$router.push({ name: 'home' })
											} else {
												if(response.data.ErrorCod === 50 || response.data.ErrorCod === 60 || response.data.ErrorCod === 70 || response.data.ErrorCod === 80 || response.data.ErrorCod === 90 || response.data.ErrorCod === 91 || response.data.ErrorCod === 92){
													this.$store.dispatch('cargando', false);
													this.$store.dispatch('limpiarTicketsPropiedades');
													this.$store.dispatch('limpiarTrnFechaFin');
													this.$router.push({ name: 'espectaculo', params: { espectaculoId: Number(this.$route.params.espectaculoId) }})
												} else {
													if(response.data.ErrorCod === 500){
														this.$store.dispatch('cargando', false);
														this.$store.dispatch('mostrarError', response.data.ErrorDsc)
														this.$store.dispatch('limpiarTicketsPropiedades');
														this.$store.dispatch('limpiarTrnFechaFin');
														this.$router.push({ name: 'espectaculo', params: { espectaculoId: Number(this.$route.params.espectaculoId) }})
													} else {
														if(response.data.ErrorCod === 100 || response.data.ErrorCod === 101 || response.data.ErrorCod === 102 || response.data.ErrorCod === 103 || response.data.ErrorCod === 104 || response.data.ErrorCod === 105 || response.data.ErrorCod === 106 || response.data.ErrorCod === 107 || response.data.ErrorCod === 113 || response.data.ErrorCod === 114 || response.data.ErrorCod === 115 || response.data.ErrorCod === 116 || response.data.ErrorCod === 117 || response.data.ErrorCod === 130 || response.data.ErrorCod === 131 || response.data.ErrorCod === 132 || response.data.ErrorCod === 133 || response.data.ErrorCod === 134){
															this.$store.dispatch('cargando', false);
															this.hayError = true
															this.$store.dispatch('mostrarError', response.data.ErrorDsc)
															this.pagando = false
														} else {
															this.$store.dispatch('cargando', false);
															this.$store.dispatch('limpiarTicketsPropiedades');
															this.$store.dispatch('limpiarTrnFechaFin');
															this.$router.push({ name: 'home' })
														}
													}
												}
											}
										}
									}
								} catch (error) {
									this.$router.push({ name: 'error' });
								}
							} else {
								this.pagando = false;
								this.$store.dispatch('mostrarError', 'Ocurrió un error. Intente más tarde.')
								this.$router.push({ name: 'home' })
							}
						} else {
							this.pagando = false;
							this.$store.dispatch('cargando', false);
						}
					} else {
						this.pagando = false;
						this.$store.dispatch('mostrarError', this.errorMsg)
						this.$store.dispatch('cargando', false);
					}
				} else {
					this.pagando = false;
					this.$store.dispatch('cargando', false);
				}
			},
			async tiposDocumentos(){
				// Obtengo tipos de documento
				try {
					let response = await axios.post('/WSDocumentoTipo', {});

					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cargoPreselecciones(){
				// Cargo las preselecciones de personas
				try {
					let response = await axios.post('/WSPersonasListar', { UsuarioId: this.usuarioId }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} })
					
					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							let preseleccion;
							let sdtPersonas = response.data.SDTPersona;
							let preText;

							preseleccion = {
								personaId: 0, 
								personaPreText: null,
								personaNombre: null,
								personaApellido: null,
								personaDocumentoTipo: null,
								personaDocumento: null,
								personaSocioNro: null,
								// personaSocioCategoria: null,
								personaDocumentoTipoAbr: null,
								personaTelefono: null,
								descripcion: '(No utilizar preselección de persona)'
							}
							this.preselecciones.push(preseleccion);

							for(var i=0; i<sdtPersonas.length; i++){
								if(i === 0){
									// Es la persona del usuario
									preText = 'Yo: '
								} else {
									preText = ''
								}

								let dsc = '';
								// if(sdtPersonas[i].PersonaSocioNro){
								// 	dsc = preText + ' ' + sdtPersonas[i].PersonaNombre + ' ' + sdtPersonas[i].PersonaApellido + ' - ' +  sdtPersonas[i].PersonaDocumentoTipoAbreviacion + ' ' + sdtPersonas[i].PersonaDocumento + ' - Socio ' + sdtPersonas[i].PersonaSocioNro
								// } else {
								// 	dsc = preText + ' ' + sdtPersonas[i].PersonaNombre + ' ' + sdtPersonas[i].PersonaApellido + ' - ' +  sdtPersonas[i].PersonaDocumentoTipoAbreviacion + ' ' + sdtPersonas[i].PersonaDocumento
								// }

								dsc = preText + ' ' + sdtPersonas[i].PersonaNombre + ' ' + sdtPersonas[i].PersonaApellido + ' - ' +  sdtPersonas[i].PersonaDocumentoTipoAbreviacion + ' ' + sdtPersonas[i].PersonaDocumento

								preseleccion = {
									personaId: sdtPersonas[i].PersonaId, 
									personaPreText: preText,
									personaNombre: sdtPersonas[i].PersonaNombre, 
									personaApellido: sdtPersonas[i].PersonaApellido, 
									personaDocumentoTipo: sdtPersonas[i].PersonaDocumentoTipoId, 
									personaDocumento: sdtPersonas[i].PersonaDocumento, 
									personaSocioNro: sdtPersonas[i].PersonaSocioNro, 
									// personaSocioCategoria: sdtPersonas[i].PersonaSocioCategoriaNombre,
									personaDocumentoTipoAbr: sdtPersonas[i].PersonaDocumentoTipoAbreviacion,
									personaTelefono: sdtPersonas[i].PersonaTelefono,
									descripcion: dsc
								}
								this.preselecciones.push(preseleccion);
							}
						} else {
							// Redirigir a 404 (no se encontró espectáculo)
							this.$router.push({ name: 'error' });
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cargoEspectaculo(){
				// Obtengo espectáculo
				try {
					let response = await axios.post('/WSEspectaculo', { 'EspectaculoId' : Number(this.$route.params.espectaculoId) });
					
					if(response.data.ErrorCod === 0){
						var data = response.data.SDTEspectaculo;

						this.espectaculo.id = Number(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						// this.espectaculo.descripcion = data.EspectaculoDescripcion;
						this.espectaculo.tipoId = Number(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioDireccion = data.EscenarioDireccion;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;
						this.monedaId = data.MonedaId;
						this.monedaSimbolo = data.MonedaSimbolo;

						this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
						this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
						this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;

						this.espectaculo.medioPagoId = Number(data.MedioPagoId);
						this.espectaculo.medioPagoNombre = data.MedioPagoNombre;
						this.espectaculo.medioPagoIconoB64 = data.MedioPagoIconoB64;
						if(data.MedioPagoCuotas){
							if(Number(data.MedioPagoCuotas) > 0 && Number(data.MedioPagoCuotas) < 13){
								this.espectaculo.medioPagoCuotas = Number(data.MedioPagoCuotas);
							} else {
								this.espectaculo.medioPagoCuotas = 1
							}
						}
					} else {
						// Redirigir a 404 (no se encontró espectáculo)
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cargoDatosComplementarios(){
				try {
					let response = await axios.post('/WSEspectaculoDatosComplCanje', { EspectaculoId : Number(this.$route.params.espectaculoId) });
					
					if(response.data.ErrorCod === 0){
						response.data.SDTDatosComplementarios.map((d)=>{
							let opciones = [];
							let opcion = {}

							if(d.Opciones.length){
								for(let i = 0; i<d.Opciones.length; i++){
									opcion = {
										valor: d.Opciones[i].ComplementoOpcionId,
										descripcion: d.Opciones[i].ComplementoOpcionValor
									}

									opciones.push(opcion)
								}
							}
							
							let datoComplementario = {
								ComplementoId: d.ComplementoId,
								ComplementoNombre: d.ComplementoNombre,
								ComplementoTipo: d.ComplementoTipo,
								Opciones: opciones,
								EspectaculoComplementoObligatorio: d.EspectaculoComplementoObligatorio
							}

							this.datosComplementarios.push(datoComplementario);

							for(let j = 0; j<this.tickets.length; j++){
								this.tickets[j].datosComplementarios.push({ ComplementoId: d.ComplementoId, Valor: null });
							}
						});
					}
				} catch (error) {
					console.log('Error al cargar datos complementarios')
				}
			},
			expiracionTiempo(){
				// if(this.redirigidoAMP === false){
				// 	// Chequeo que no tenga transacciones en curso
				// 	axios.post('/WSTransaccionCancelar', {
				// 		UsuarioId : this.usuarioId,
				// 		Log: 'EspectaculoCompra ExpiracionTiempo'
				// 	},
				// 	{
				// 		headers: {"Authorization" : `Bearer ${this.$store.state.token}`}
				// 	})
				// 	.then(response => {
				// 		if(response.data.ErrorCod !== 0){
				// 			if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
				// 				this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
				// 			}
				// 		}
				// 	})

				// 	this.$store.dispatch('limpiarTicketsPropiedades');
				// 	this.$router.push({ name: 'home' })
				// } else {
					this.$store.dispatch('limpiarTicketsPropiedades');
					this.$router.push({ name: 'home' })
				// }
			},
			async calcularCategoriaSocio(i){
				if(this.tickets[i].documentoPersona && this.tickets[i].tipoDocPersona.valor){
					this.tickets[i].recalculandoInfo = true;


					// -----------------------------------------------
					// --- HARCODEO CATEGORIA DE SOCIO A BUTAQUISTA
					// -----------------------------------------------
					// var socioCategoriaId = 2
					// this.tickets[i].catSocioPersonaId = socioCategoriaId
					// this.tickets[i].nroSocioPersona = '79110';

					// for(var n=0; n<this.categoriasSocios.length; n++){
					// 	if(Number(this.categoriasSocios[n].id) === Number(socioCategoriaId)){
					// 		this.tickets[i].catSocioPersona = this.categoriasSocios[n].nombre
					// 		this.tickets[i].precioTicket = this.categoriasSocios[n].precioOriginal
					// 		break;
					// 	}
					// }

					if(this.sectorEsVisitante){
						this.tickets[i].catSocioPersonaId = this.categoriasSocios[0].id
						this.tickets[i].nroSocioPersona = ''
						this.tickets[i].catSocioPersona = this.categoriasSocios[0].nombre
						this.tickets[i].precioTicket = this.categoriasSocios[0].precioOriginal
					} else {
						try {
							// var socioNro = this.tickets[i].nroSocioPersona;

							// Llamo a ws que calcula categoría de socio a partir de número de socio
							let response = await axios.post('/WSEspectaculoPersonaValidar2', { EspectaculoId: Number(this.$route.params.espectaculoId), PersonaDocumentoTipoId: Number(this.tickets[i].tipoDocPersona.valor), PersonaDocumento: this.tickets[i].documentoPersona }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

							if(response.data.ErrorCod === 400){
								this.$store.dispatch('mostrarError', 'Ocurrió un error')
								this.$router.push({ name: 'home' })
							} else {
								if(response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
								} else {
									if(response.data.ErrorCod === 12){
										this.$store.dispatch('mostrarError', 'El documento ingresado es incorrecto')
									} else {
										if(response.data.ErrorCod === 122 || response.data.ErrorCod === 200 || response.data.ErrorCod === 125){
											if(response.data.ErrorCod === 122){
												this.$store.dispatch('mostrarError', 'Estimado Socio se encuentra inhabilitado por deuda para canje o venta de entradas. Contáctese al Departamento de Socios al mail socios@nacional.uy, WhatsApp 099001899 o al teléfono 24873636.')
											}

											if(response.data.ErrorCod === 200){
												this.$store.dispatch('mostrarError', 'La cantidad de entradas dispuestas por Nacional para Carnets AUF se encuentran agotadas')
											}

											if(response.data.ErrorCod === 125){
												this.$store.dispatch('mostrarError', response.data.ErrorDsc)
											}

											var socioCategoriaId = response.data.PersonaSocioCategoriaId
											this.tickets[i].catSocioPersonaId = socioCategoriaId
											this.tickets[i].nroSocioPersona = response.data.PersonaSocioNro;
											this.tickets[i].tienePin = response.data.SocioRegistroTienePIN
											if (response.data.PersonaNombre && response.data.PersonaApellido){
												this.tickets[i].tieneNombreApellido = true
												this.tickets[i].nombrePersona = response.data.PersonaNombre
												this.tickets[i].apellidoPersona = response.data.PersonaApellido
											} else {
												this.tickets[i].tieneNombreApellido = false
											}

											for(var n=0; n<this.categoriasSocios.length; n++){
												if(Number(this.categoriasSocios[n].id) === Number(socioCategoriaId)){
													this.tickets[i].catSocioPersona = this.categoriasSocios[n].nombre
													this.tickets[i].precioTicket = this.categoriasSocios[n].precioOriginal
													break;
												}
											}
										} else {
											var socioCategoriaId = response.data.PersonaSocioCategoriaId
											this.tickets[i].catSocioPersonaId = socioCategoriaId
											this.tickets[i].nroSocioPersona = response.data.PersonaSocioNro;
											this.tickets[i].tienePin = response.data.SocioRegistroTienePIN
											if (response.data.PersonaNombre && response.data.PersonaApellido){
												this.tickets[i].tieneNombreApellido = true
												this.tickets[i].nombrePersona = response.data.PersonaNombre
												this.tickets[i].apellidoPersona = response.data.PersonaApellido
											} else {
												this.tickets[i].tieneNombreApellido = false
											}

											for(var n=0; n<this.categoriasSocios.length; n++){
												if(Number(this.categoriasSocios[n].id) === Number(socioCategoriaId)){
													this.tickets[i].catSocioPersona = this.categoriasSocios[n].nombre
													this.tickets[i].precioTicket = this.categoriasSocios[n].precioOriginal
													break;
												}
											}
										}
									}
								}
							}

							// if(Number(this.tickets[i].precioTicket) > 0){
							// if(this.datosCompletos === true && this.total > 0){
							// 	await this.crearOrdenDePago();
							// }
						} catch (error) {
							this.$router.push({ name: 'error' });
						}
					}

					this.tickets[i].recalculandoInfo = false;
				}
			},
			async personaValidar(){
				this.isPersonaValidarOk = true;

				try {
					for(let i=0; i<this.tickets.length; i++){
						// Llamo a ws que calcula categoría de socio a partir de número de socio
						let response = await axios.post('/WSEspectaculoPersonaValidar2', { EspectaculoId: Number(this.$route.params.espectaculoId), PersonaDocumentoTipoId: Number(this.tickets[i].tipoDocPersona.valor), PersonaDocumento: this.tickets[i].documentoPersona }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

						if(response.data.ErrorCod === 400){
							this.isPersonaValidarOk = false;
							this.$store.dispatch('mostrarError', 'No es posible establecer la comunicación');
							break;
						} else {
							// if(response.data.ErrorCod === 10 || response.data.ErrorCod === 11 || response.data.ErrorCod === 12 || response.data.ErrorCod === 122 || response.data.ErrorCod === 123 || response.data.ErrorCod === 124 || response.data.ErrorCod === 30){
							if(response.data.ErrorCod === 10 || response.data.ErrorCod === 11 || response.data.ErrorCod === 12 || response.data.ErrorCod === 30){
								this.isPersonaValidarOk = false;
								this.$store.dispatch('mostrarError', 'Ticket #' + (i+1) + ': ' + response.data.ErrorDsc)
								break;
							} else {
								var socioCategoriaId = response.data.PersonaSocioCategoriaId
								this.tickets[i].catSocioPersonaId = socioCategoriaId
								this.tickets[i].nroSocioPersona = response.data.PersonaSocioNro;
								this.tickets[i].tienePin = response.data.SocioRegistroTienePIN
								if (response.data.PersonaNombre && response.data.PersonaApellido){
									this.tickets[i].tieneNombreApellido = true
									this.tickets[i].nombrePersona = response.data.PersonaNombre
									this.tickets[i].apellidoPersona = response.data.PersonaApellido
								} else {
									this.tickets[i].tieneNombreApellido = false
								}

								for(var n=0; n<this.categoriasSocios.length; n++){
									if(Number(this.categoriasSocios[n].id) === Number(socioCategoriaId)){
										this.tickets[i].catSocioPersona = this.categoriasSocios[n].nombre
										this.tickets[i].precioTicket = this.categoriasSocios[n].precioOriginal
										break;
									}
								}
							}
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async promptPagar(){
				// this.$store.dispatch('cargando', true);
				// await this.validacionDatos();

				// if(this.hayError === false){
				// 	await this.personaValidar();

				// 	if(this.isPersonaValidarOk === true){
				// 		// try {
				// 		// 	// Emitir ticket
				// 		// 	var SDTTicket;
				// 		// 	var TicketItems = [];
				// 		// 	var TicketItem;
				// 		// 	var ticketTipo;

				// 		// 	for(var n=0; n<this.tickets.length; n++){
				// 		// 		if(Number(this.tickets[n].precioTicket) === 0){
				// 		// 			ticketTipo = 'C'
				// 		// 		} else {
				// 		// 			ticketTipo = 'V'
				// 		// 		}

				// 		// 		TicketItem = {
				// 		// 			Id: Number(n + 1),
				// 		// 			MonedaId: this.monedaId,
				// 		// 			TicketMonto: this.tickets[n].precioTicket,
				// 		// 			TicketTipo: ticketTipo,
				// 		// 			TribunaId: this.tribunaId,
				// 		// 			SectorCod: this.sectorCod,
				// 		// 			FilaId: this.tickets[n].filaId,
				// 		// 			AsientoId: this.tickets[n].asientoId,
				// 		// 			PersonaNombre: this.tickets[n].nombrePersona,
				// 		// 			PersonaApellido: this.tickets[n].apellidoPersona,
				// 		// 			PersonaDocumentoTipoId: this.tickets[n].tipoDocPersona.valor,
				// 		// 			PersonaDocumento: this.tickets[n].documentoPersona,
				// 		// 			PersonaSocioNro: this.tickets[n].nroSocioPersona,
				// 		// 			PersonaButacaNro: this.tickets[n].nroButacaPersona,
				// 		// 			PersonaSocioCategoriaid: Number(this.tickets[n].catSocioPersonaId),
				// 		// 			TicketButacaNro: ''
				// 		// 		}
				// 		// 		TicketItems.push(TicketItem);
				// 		// 	}

				// 		// 	SDTTicket = { EspectaculoId: Number(this.$route.params.espectaculoId), TransaccionId: this.transaccionId, Ticket: TicketItems}

				// 		// 	let response = await axios.post('/WSTicket2', { UsuarioId: this.usuarioId, SDTTicketJSON: JSON.stringify(SDTTicket) }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

				// 		// 	if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11 || response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
				// 		// 		this.$store.dispatch('cargando', false);
				// 		// 		this.$store.dispatch('limpiarTicketsPropiedades');
				// 		// 		this.$store.dispatch('limpiarTrnFechaFin');
				// 		// 		this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
				// 		// 	} else {
				// 		// 		if(response.data.ErrorCod === 0){
				// 		// 			this.$store.dispatch('cargando', false);
				// 		// 			this.$modal.show('promptPago');
				// 		// 		} else {
				// 		// 			if(response.data.ErrorCod === 30 || response.data.ErrorCod === 40 || response.data.ErrorCod === 110 || response.data.ErrorCod === 111 || response.data.ErrorCod === 112){
				// 		// 				this.$store.dispatch('cargando', false);
				// 		// 				this.$store.dispatch('limpiarTicketsPropiedades');
				// 		// 				this.$store.dispatch('limpiarTrnFechaFin');
				// 		// 				this.$router.push({ name: 'home' })
				// 		// 			} else {
				// 		// 				if(response.data.ErrorCod === 50 || response.data.ErrorCod === 60 || response.data.ErrorCod === 70 || response.data.ErrorCod === 80 || response.data.ErrorCod === 90 || response.data.ErrorCod === 91 || response.data.ErrorCod === 92){
				// 		// 					this.$store.dispatch('cargando', false);
				// 		// 					this.$store.dispatch('limpiarTicketsPropiedades');
				// 		// 					this.$store.dispatch('limpiarTrnFechaFin');
				// 		// 					this.$router.push({ name: 'espectaculo', params: { espectaculoId: Number(this.$route.params.espectaculoId) }})
				// 		// 				} else {
				// 		// 					if(response.data.ErrorCod === 100 || response.data.ErrorCod === 101 || response.data.ErrorCod === 102 || response.data.ErrorCod === 103 || response.data.ErrorCod === 104 || response.data.ErrorCod === 105 || response.data.ErrorCod === 106 || response.data.ErrorCod === 107 || response.data.ErrorCod === 113 || response.data.ErrorCod === 114 || response.data.ErrorCod === 115 || response.data.ErrorCod === 116){
				// 		// 						this.$store.dispatch('cargando', false);
				// 		// 						this.hayError = true
				// 		// 						this.$store.dispatch('mostrarError', response.data.ErrorDsc)
				// 		// 						this.canjeando = false
				// 		// 					} else {
				// 		// 						this.$store.dispatch('cargando', false);
				// 		// 						this.$store.dispatch('limpiarTicketsPropiedades');
				// 		// 						this.$store.dispatch('limpiarTrnFechaFin');
				// 		// 						this.$router.push({ name: 'home' })
				// 		// 					}
				// 		// 				}
				// 		// 			}
				// 		// 		}
				// 		// 	}
				// 		// } catch (error) {
				// 		// 	this.$router.push({ name: 'error' });
				// 		// }

						
				// 	} else {
				// 		this.$store.dispatch('cargando', false);
				// 	}
				// }
			},
			async canjear(){
				this.$store.dispatch('cargando', true);
				await this.validacionDatos();

				if(this.total === 0){
					if(this.hayError === false){
						this.canjeando = true;
						// await this.agregarAmigos();

						var SDTPersona = []

						for(var m=0; m<this.tickets.length; m++){
							var SDTPersonaItem = {
								PersonaNombre: this.tickets[m].nombrePersona.trim(),
								PersonaApellido: this.tickets[m].apellidoPersona.trim(),
								PersonaDocumentoTipoId: Number(this.tickets[m].tipoDocPersona.valor),
								PersonaDocumento: this.tickets[m].documentoPersona,
								PersonaSocioNro: this.tickets[m].nroSocioPersona,
								PersonaButacaNro: this.tickets[m].nroButacaPersona,
								PersonaSocioCategoriaid: Number(this.tickets[m].catSocioPersonaId),
								// PersonaTelefono: this.tickets[m].telefonoPersona
								PersonaTelefono: ''
							}
							SDTPersona.push(SDTPersonaItem);
						}

						// Emitir ticket
						var SDTTicket;
						var TicketItems = [];
						var TicketItem;
						var ticketTipo;
						let TicketComplemento;
						let SDTComplementosValores = [];
						let SDTComplementosValoresJSON = '';

						for(var n=0; n<this.tickets.length; n++){
							if(Number(this.tickets[n].precioTicket) === 0){
								ticketTipo = 'C'
							} else {
								ticketTipo = 'V'
							}

							TicketItem = {
								Id: Number(n + 1),
								TicketMonto: this.tickets[n].precioTicket,
								TicketTipo: ticketTipo,
								TribunaId: this.tribunaId,
								SectorCod: this.sectorCod,
								FilaId: this.tickets[n].filaId,
								AsientoId: this.tickets[n].asientoId,
								PersonaNombre: this.tickets[n].nombrePersona.trim(),
								PersonaApellido: this.tickets[n].apellidoPersona.trim(),
								PersonaDocumentoTipoId: this.tickets[n].tipoDocPersona.valor,
								PersonaDocumento: this.tickets[n].documentoPersona,
								// PersonaTelefono: this.tickets[n].telefonoPersona,
								PersonaTelefono: '',
								PersonaSocioNro: this.tickets[n].nroSocioPersona,
								PersonaButacaNro: this.tickets[n].nroButacaPersona,
								PersonaSocioCategoriaid: Number(this.tickets[n].catSocioPersonaId),
								TicketButacaNro: '',
								TicketPIN: this.tickets[n].tienePin ? this.tickets[n].pin.trim() : ''
							}
							TicketItems.push(TicketItem);

							for(let s=0; s<this.tickets[n].datosComplementarios.length; s++){
								let value = null;

								if(this.datosComplementarios[s].ComplementoTipo === 'O'){
									if(this.tickets[n].datosComplementarios[s].Valor){
										value = this.tickets[n].datosComplementarios[s].Valor.valor;
									}
								} else {
									if(this.tickets[n].datosComplementarios[s].Valor && this.tickets[n].datosComplementarios[s].Valor.trim() !== ''){
										value = this.tickets[n].datosComplementarios[s].Valor;
									}
								}

								if(value){
									TicketComplemento = {
										Index: Number(n + 1),
										ComplementoId: this.tickets[n].datosComplementarios[s].ComplementoId,
										ComplementoRegistroValor: value
									}

									SDTComplementosValores.push(TicketComplemento);
								}
							}
						}

						SDTComplementosValoresJSON = JSON.stringify(SDTComplementosValores);

						SDTTicket = { EspectaculoId: Number(this.$route.params.espectaculoId), TransaccionId: this.transaccionId, Ticket: TicketItems}

						try {
							let response = await axios.post('/WSTicket2', {UsuarioId: this.usuarioId, SDTTicketJSON: JSON.stringify(SDTTicket), SDTPersonaJSON: JSON.stringify(SDTPersona), SDTComplementosValoresJSON: SDTComplementosValoresJSON}, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`}});

							if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11 || response.data.ErrorCod === 20 || response.data.ErrorCod === 21){
								this.$store.dispatch('cargando', false);
								this.$store.dispatch('limpiarTicketsPropiedades');
								this.$store.dispatch('limpiarTrnFechaFin');
								this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
							} else {
								if(response.data.ErrorCod === 0){
									// Ticket emitido correctamente
									this.$store.dispatch('cargando', false);
									this.$store.dispatch('limpiarTicketsPropiedades');
									this.$store.dispatch('limpiarTrnFechaFin');
									this.$router.push({ name: 'espectaculo-canje-fin', params: { isOk: 'isok' } })
								} else {
									if(response.data.ErrorCod === 30 || response.data.ErrorCod === 40 || response.data.ErrorCod === 110 || response.data.ErrorCod === 111 || response.data.ErrorCod === 112){
										this.$store.dispatch('cargando', false);
										this.$store.dispatch('limpiarTicketsPropiedades');
										this.$store.dispatch('limpiarTrnFechaFin');
										this.$router.push({ name: 'home' })
									} else {
										if(response.data.ErrorCod === 50 || response.data.ErrorCod === 60 || response.data.ErrorCod === 70 || response.data.ErrorCod === 80 || response.data.ErrorCod === 90 || response.data.ErrorCod === 91 || response.data.ErrorCod === 92){
											this.$store.dispatch('cargando', false);
											this.$store.dispatch('limpiarTicketsPropiedades');
											this.$store.dispatch('limpiarTrnFechaFin');
											this.$router.push({ name: 'espectaculo', params: { espectaculoId: Number(this.$route.params.espectaculoId) }})
										} else {
											if(response.data.ErrorCod === 500){
												this.$store.dispatch('cargando', false);
												this.$store.dispatch('mostrarError', response.data.ErrorDsc)
												this.$store.dispatch('limpiarTicketsPropiedades');
												this.$store.dispatch('limpiarTrnFechaFin');
												this.$router.push({ name: 'espectaculo', params: { espectaculoId: Number(this.$route.params.espectaculoId) }})
											} else {
												if(response.data.ErrorCod === 100 || response.data.ErrorCod === 101 || response.data.ErrorCod === 102 || response.data.ErrorCod === 103 || response.data.ErrorCod === 104 || response.data.ErrorCod === 105 || response.data.ErrorCod === 106 || response.data.ErrorCod === 107 || response.data.ErrorCod === 113 || response.data.ErrorCod === 114 || response.data.ErrorCod === 115 || response.data.ErrorCod === 116 || response.data.ErrorCod === 117){
													this.$store.dispatch('cargando', false);
													this.hayError = true
													this.$store.dispatch('mostrarError', response.data.ErrorDsc)
													this.canjeando = false
												} else {
													this.$store.dispatch('cargando', false);
													this.$store.dispatch('limpiarTicketsPropiedades');
													this.$store.dispatch('limpiarTrnFechaFin');
													this.$router.push({ name: 'home' })
												}
											}
										}
									}
								}
							}
						} catch (error) {
							this.$router.push({ name: 'error' });
						}
					} else {
						this.$store.dispatch('mostrarError', this.errorMsg)
					}
				}

				this.$store.dispatch('cargando', false);
			},
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async cambioPreseleccion(i){
				var preseleccionPersona;
				if(Number(this.tickets[i].preseleccionPersona.personaId) !== 0){
					this.tickets[i].esPreseleccion = true

					preseleccionPersona = this.preselecciones.find(p => Number(p.personaId) === Number(this.tickets[i].preseleccionPersona.personaId));

					for(let n=0; n<this.tipoDocumentos.length; n++){
						if(Number(preseleccionPersona.personaDocumentoTipo) === Number(this.tipoDocumentos[n].valor)){
							this.tickets[i].tipoDocPersona = this.tipoDocumentos[n];
							break;
						}
					}

					this.tickets[i].personaId = preseleccionPersona.personaId
					this.tickets[i].nombrePersona = preseleccionPersona.personaNombre
					this.tickets[i].apellidoPersona = preseleccionPersona.personaApellido
					// this.tickets[i].tipoDocPersona = preseleccionPersona.personaDocumentoTipo
					this.tickets[i].documentoPersona = preseleccionPersona.personaDocumento
					// this.tickets[i].nroSocioPersona = preseleccionPersona.personaSocioNro
					// this.tickets[i].catSocioPersona = preseleccionPersona.personaSocioCategoria
					this.tickets[i].telefonoPersona = preseleccionPersona.personaTelefono
					this.tickets[i].guardarInformacionPersona = false

					await this.calcularCategoriaSocio(i);
				} else {
					this.tickets[i].esPreseleccion = false
				}
			},
			async validacionDatos(){
				this.hayError = false
				var documentoActual;
				var nroSocioActual;
				for(var n=0; n<this.tickets.length; n++){
					documentoActual = this.tickets[n].documentoPersona.trim()
					nroSocioActual = this.tickets[n].nroSocioPersona.trim()

					if(this.tickets[n].nombrePersona.trim().length <= 1){
						this.hayError = true
						this.errorMsg = 'Ingrese nombre de persona para el ticket ' + (n+1)
						break;
					}

					if(this.tickets[n].apellidoPersona.trim().length <= 1){
						this.hayError = true
						this.errorMsg = 'Ingrese apellido de persona para el ticket ' + (n+1)
						break;
					}

					if(this.tickets[n].documentoPersona.trim().length <= 1){
						this.hayError = true
						this.errorMsg = 'Ingrese documento de persona para el ticket ' + (n+1)
						break;
					}

					if(this.tickets[n].tienePin && this.tickets[n].pin.trim().length === 0){
						this.hayError = true
						this.errorMsg = 'Ingrese PIN de socio para el ticket ' + (n+1)
						break;
					}

					if(this.tickets[n].tienePin && this.tickets[n].pin.trim().length < 4 || this.tickets[n].pin.trim().length > 8){
						this.hayError = true
						this.errorMsg = 'Formato de PIN de socio incorrecto para el ticket ' + (n+1)
						break;
					}

					// if(!this.tickets[n].telefonoPersona){
					// 	this.hayError = true
					// 	this.errorMsg = 'Ingrese teléfono de persona para el ticket ' + (n+1)
					// 	break;
					// }

					// if(this.tickets[n].telefonoPersona.length < 8 || this.tickets[n].telefonoPersona.length > 20){
					// 	this.hayError = true
					// 	this.errorMsg = 'Ticket ' + (n+1) + ': teléfono incorrecto'
					// 	break;
					// }

					// Chequeo documentos y nro de socios repetidos
					for(var m=0; m<this.tickets.length; m++){
						if((m !== n) && documentoActual === this.tickets[m].documentoPersona){
							this.hayError = true
							this.errorMsg = 'Hay documentos repetidos'
							break;
						}

						// if((m !== n) && nroSocioActual === this.tickets[m].nroSocioPersona && nroSocioActual.trim() !== ''){
						// 	this.hayError = true
						// 	this.errorMsg = 'Hay números de socio repetidos'
						// 	break;
						// }
					}

					// Validación datos complementarios
					for(let k=0; k<this.datosComplementarios.length; k++){
						let isDatoObligatorio = this.datosComplementarios[k].EspectaculoComplementoObligatorio;

						if(isDatoObligatorio){
							if(!this.tickets[n].datosComplementarios[k].Valor && this.datosComplementarios[k].ComplementoTipo === 'O'){
								this.hayError = true
								this.errorMsg = 'Ticket ' + (n+1) + ': debes seleccionar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase();
								break;
							}

							if(this.datosComplementarios[k].ComplementoTipo !== 'O'){
								if(!this.tickets[n].datosComplementarios[k].Valor){
									this.hayError = true
									this.errorMsg = 'Ticket ' + (n+1) + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase();
									break;
								} else {
									if(this.tickets[n].datosComplementarios[k].Valor.trim() === ''){
										this.hayError = true
										this.errorMsg = 'Ticket ' + (n+1) + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase();
										break;
									}
								}
							}
						}
					}
				}
			},
			cancelarReservaModal(){
				this.$modal.show('promptCancelarReserva');
			},
			cancelarReserva(){
				// Chequeo que no tenga transacciones en curso
				axios.post('/WSTransaccionCancelar', {
					UsuarioId : this.usuarioId,
					Log: 'EspectaculoCompra CancelarReserva'
				},
				{
					headers: {"Authorization" : `Bearer ${this.$store.state.token}`}
				})
				.then(response => {
					if(response.data.ErrorCod !== 0){
						if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
							this.$store.dispatch('destroyToken')
							.then(response => {this.$router.push({ name: 'login' })})
						}
					}
				})

				this.$store.dispatch('limpiarTicketsPropiedades');
				this.$router.push({ name: 'home' })
			},
			cerrarModal(){
				this.$modal.hide('promptCancelarReserva');
			},
			// async agregarAmigos(){
			// 	var SDTPersona = []

			// 	for(var m=0; m<this.tickets.length; m++){
			// 		var SDTPersonaItem = {
			// 			PersonaNombre: this.tickets[m].nombrePersona,
			// 			PersonaApellido: this.tickets[m].apellidoPersona,
			// 			PersonaDocumentoTipoId: Number(this.tickets[m].tipoDocPersona.valor),
			// 			PersonaDocumento: this.tickets[m].documentoPersona,
			// 			PersonaSocioNro: this.tickets[m].nroSocioPersona,
			// 			PersonaButacaNro: this.tickets[m].nroButacaPersona,
			// 			PersonaSocioCategoriaid: Number(this.tickets[m].catSocioPersonaId)
			// 		}
			// 		SDTPersona.push(SDTPersonaItem);
			// 	}

			// 	if(SDTPersona.length > 0){
			// 		// Cargo las preselecciones de personas
			// 		let response = await axios.post('/WSAmigo', { UsuarioId: this.usuarioId, SDTPersonaJSON: JSON.stringify(SDTPersona)	}, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`}});

			// 		if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
			// 			this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
			// 		}
			// 	}
			// },
			updateTimer() {
				if (
				this.times[3].time > 0 ||
				this.times[2].time > 0 ||
				this.times[1].time > 0 ||
				this.times[0].time > 0
				) {
				this.getTimeRemaining();
				this.updateProgressBar();
				} else {
				clearTimeout(this.timeinterval);
				// this.times[3].time = this.times[2].time = this.times[1].time = this.times[0].time = 0;
				this.progress = 0;
				}
			},
			getTimeRemaining() {
				// .toLocaleString('en-US', {timeZone: 'America/Montevideo'})
				// console.log(this.transaccionFechafin)
				// let prueba = new Date();
				// let prueba2 = new Date(this.transaccionFechafin);
				// console.log(prueba2.getTimezoneOffset())
				// console.log(prueba.getTimezoneOffset())
				// console.log(new Date())

				const horaActualMontevideo = this.convertTZ(new Date(), 'America/Montevideo');
				// let t = Date.parse(new Date(this.transaccionFechafin)) - Date.parse(new Date());
				let t = Date.parse(new Date(this.transaccionFechafin)) - Date.parse(horaActualMontevideo);
				
				if(t >= 0) {
					this.times[3].time = Math.floor(t / 1000 % 60); //seconds
					this.times[2].time = Math.floor(t / 1000 / 60 % 60); //minutes
					this.times[1].time = Math.floor(t / (1000 * 60 * 60) % 24); //hours
					this.times[0].time = Math.floor(t / (1000 * 60 * 60 * 24)); //days
				} else {
					this.times[3].time = this.times[2].time = this.times[1].time = this.times[0].time = 0;
					this.progress = 0;
				}
			},
			convertTZ(date, tzString) {
				return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
			},
			updateProgressBar() {
				let startTime = Date.parse(new Date(this.startTime));
				let currentTime = Date.parse(new Date());
				let endTime = Date.parse(new Date(this.transaccionFechafin));
				let interval = parseFloat(
				(currentTime - startTime) / (endTime - startTime) * 100
				).toFixed(2);
				this.progress = 100-interval;
			},
			guessingPaymentMethod() {
				if (this.bin && this.bin.length >= 6) {
					window.Mercadopago.getPaymentMethod({'bin': this.bin}, (status, response) => {
						if (status === 200) {
							this.paymentType = response
							this.paymentTypeId = response[0].id
						} else {
							this.paymentType = null
							this.paymentTypeId = ''
						}
					})
				} else {
					this.paymentType = null
					this.paymentTypeId = ''
				}

				if(this.paymentTypeId === 'diners'){
					// Formateo
					// this.form.cardNumber = this.form.cardNumber ? this.form.cardNumber.split('').map(digito => {
					// 	return Number(digito) > 0 || digito === '0' ? digito: ''
					// }).join('').split('').map((numero, index) => {
					// 	return index > 3 && index % 4 === 0 ? ` ${numero}`: numero
					// }).join('') : ''
				} else {
					// Formateo
					// this.form.cardNumber = this.form.cardNumber ? this.form.cardNumber.split('').map(digito => {
					// 	return Number(digito) > 0 || digito === '0' ? digito: ''
					// }).join('').split('').map((numero, index) => {
					// 	return index > 3 && index % 4 === 0 ? ` ${numero}`: numero
					// }).join('') : ''
				}
			},
			formatoEmail () {
				if (this.form.email) {
					const reg = /^((\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)|(\s*))$/
					this.errorPago = reg.test(this.form.email) ? null: 'Error en formato email'
				}
			},
			formatoDoc () {
				const numero = this.docNumber
				? this.docNumber.split('').map(digito => {
					return Number(digito) > 0 || digito === '0' ? digito: ''
				}).join(''): '0'
				if (Number(numero) > 0) {
					this.form.docNumber = Number(numero)
					this.docNumber = this.form.docNumber.toString().split('').reverse().map((numero, index) => {
						return index === 1 ? `${numero}-`: index === 4 || index === 7 ? `${numero}.`: numero
					}).reverse().join('')
				} else {
					this.form.docNumber = 0
					this.docNumber = null
				}
			},
			pagar(){
				this.pagando = true
				// s_pagar(this)
			},
			altaPago(){
				var SDTTicket;
				var TicketItems = [];
				var TicketItem;
				var ticketTipo;

				for(var n=0; n<this.tickets.length; n++){
					if(Number(this.tickets[n].precioTicket) === 0){
						ticketTipo = 'C'
					} else {
						ticketTipo = 'V'
					}

					TicketItem = {
						Id: Number(n + 1),
						MonedaId: this.monedaId,
						TicketMonto: this.tickets[n].precioTicket,
						TicketTipo: ticketTipo,
						TribunaId: this.tribunaId,
						SectorCod: this.sectorCod,
						FilaId: this.tickets[n].filaId,
						AsientoId: this.tickets[n].asientoId,
						PersonaNombre: this.tickets[n].nombrePersona,
						PersonaApellido: this.tickets[n].apellidoPersona,
						PersonaDocumentoTipoId: this.tickets[n].tipoDocPersona.valor,
						PersonaDocumento: this.tickets[n].documentoPersona,
						PersonaSocioNro: this.tickets[n].nroSocioPersona,
						PersonaButacaNro: this.tickets[n].nroButacaPersona,
						PersonaSocioCategoriaid: this.tickets[n].catSocioPersonaId,
						TicketButacaNro: ''
					}
					TicketItems.push(TicketItem);
				}

				SDTTicket = { EspectaculoId: Number(this.$route.params.espectaculoId), TransaccionId: this.transaccionId, Ticket: TicketItems}

				// Alta de pago
				axios.post('/WSPago', {
					UsuarioId: this.usuarioId,
					SDTTicketJson: JSON.stringify(SDTTicket),
					PagoIdExterno: 'Prueba1899',
					MonedaId: this.monedaId,
					PagoMonto: this.total,
					TransaccionId: this.transaccionId
				},
				{
					headers: {"Authorization" : `Bearer ${this.$store.state.token}`}
				})
				.then(response => {
					if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 11){
						this.$store.dispatch('cargando', false);
						this.$store.dispatch('limpiarTicketsPropiedades');
						this.$store.dispatch('limpiarTrnFechaFin');
						this.$store.dispatch('destroyToken')
						.then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							this.pagando = false;

							// Ticket y pagos finalizados correctamente
							this.$store.dispatch('cargando', false);
							this.$store.dispatch('limpiarTicketsPropiedades');
							this.$store.dispatch('limpiarTrnFechaFin');
							this.$router.push({ name: 'espectaculo-compra-fin', params: { isOk: 'isok' } })
						} else {
							if(response.data.ErrorCod === 20 || response.data.ErrorCod === 30 || response.data.ErrorCod === 31 || response.data.ErrorCod === 32 || response.data.ErrorCod === 33 || response.data.ErrorCod === 40 || response.data.ErrorCod === 50){
								this.$store.dispatch('cargando', false);
								this.$store.dispatch('limpiarTicketsPropiedades');
								this.$store.dispatch('limpiarTrnFechaFin');
								this.$router.push({ name: 'espectaculo', params: { espectaculoId: Number(this.$route.params.espectaculoId) }})
							} else {
								this.$store.dispatch('cargando', false);
								this.$store.dispatch('limpiarTicketsPropiedades');
								this.$store.dispatch('limpiarTrnFechaFin');
								this.$router.push({ name: 'home' })
							}
						}
					}
				})
			},
			flipCard (status) {
				this.isCardFlipped = status;
			},
			focusInput (e) {
				this.isInputFocused = true;
				let targetRef = e.target.dataset.ref;
				let target = this.$refs[targetRef];
				this.focusElementStyle = {
					width: `${target.offsetWidth}px`,
					height: `${target.offsetHeight}px`,
					transform: `translateX(${target.offsetLeft}px) translateY(${target.offsetTop}px)`
				}
			},
			blurInput() {
				let vm = this;
				setTimeout(() => {
					if (!vm.isInputFocused) {
						vm.focusElementStyle = null;
					}
				}, 200);
				vm.isInputFocused = false;
			},
			promptPagoCerrado(){
				// console.log('limpiar datos de pago')
			},
			promptPagoAbierto(){
    			document.getElementById('formEmail').focus();
			},
			cerrarPromptPago(){
				this.$modal.hide('promptPago');
			},
			promptPagoShake(){
				var shake = document.getElementsByClassName('card-form');
				shake[0].className += ' shake';

				setTimeout(function(){
                    shake[0].className = 'card-form';
                }, 820);
			}
		},
		created: function() {
			this.updateTimer();
			this.timeinterval = setInterval(this.updateTimer, 1000);
		}
	}
</script>

<style lang="scss">
	@import '../../styles/buttonMP.scss';
</style>

<style lang="scss">
	@import '../../styles/formPago.scss';

	.espectaculo-compra-page{
		.multiselect {
    		min-height: 37px;
		}

		.multiselect__select{
			height: 37px;
		}

		.multiselect__input, .multiselect__single{
			margin: 0;
			font-size: 15px;
			line-height: 22px;
			font-weight: var(--font-weight-bold);
			-webkit-letter-spacing: 0;
			-moz-letter-spacing: 0;
			-ms-letter-spacing: 0;
			letter-spacing: 0;
			color: var(--color-dark);
			font-family: var(--font-family-poppins);
			text-transform: uppercase;
			padding-left: 0;
		}

		.multiselect__tags{
			min-height: 37px;
			font-size: 15px;
			line-height: 22px;
			padding-top: 7px;
			padding-bottom: 7px;
		}

		.multiselect--disabled{
			background: transparent;
		}

		.multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select{
			background: transparent;
			color: var(--color-grey);
		}

		.multiselect--disabled{
			opacity: 1;
		}

		.multiselect--disabled .multiselect__input, .multiselect--disabled .multiselect__single{
			color: var(--color-grey);
		}
	}
</style>

<style lang="scss" scoped>
	.spinner-pago, .spinner-canje{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		@include flex(column, center, center);

		span{
			margin-top: 10px;
			font-family: var(--font-family-poppins);
			color: var(--color-blue-dark);
			font-size: 13px;
			text-transform: uppercase;
			font-weight: var(--font-weight-bold);
		}
	}

	.form-overlay{
		width: 100%;
		height: 100%;
		z-index: 900;
		opacity: 0.92;
		transition: all .2s;
		left: 0;
		top: 0;
		position: absolute;
		background: #fff;
		border-radius: 10px;
	}

	.espectaculo-compra-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.espectaculo-compra-header{
			padding-top: 72px;
			width: 100%;
			position: relative;
			height: 260px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				max-width: 1260px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
				position: relative;

				.contador{
					position: absolute;
					right: 16px;
					bottom: 36px;
					@include flex(column, center, center);
					padding: 10px;
					border: 1px solid rgba(255, 255, 255, 0.3);
					color: var(--color-white);

					.tiempo-restante-label{
						margin: 0;
						font-size: 12px;
						line-height: 1.4em;
						margin-bottom: 3px;
						font-weight: 400;
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						color: var(--color-white);
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
					}

					.tiempo-restante{
						margin: 0;
						font-size: 16px;
						line-height: 1.4em;
						margin-bottom: 0px;
						font-weight: var(--font-weight-bold);
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						color: var(--color-white);
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
					}
				}
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: var(--color-white);
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{
							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.espectaculo-compra-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1260px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.espectaculo-compra-left{
					width: calc(64% - 16px);
					background-color: var(--color-white);
					padding: 0px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					.tickets{
						width: 100%;
						margin-top: 20px;
						margin-bottom: 30px;
						display: grid;
						grid-template-columns: repeat(1, 1fr);
						grid-row-gap: 30px;

						.ticket{
							border-radius: 0px;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 15px;
							padding-left: 70px;
							position: relative;
							background-color: var(--color-white);
							transition: all .2s;

							&:after{
								content: 'Ticket';
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: calc(100% - 50px);
								@include flex(row, center, center);
								color: var(--color-white);
								writing-mode:vertical-lr;
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
								background-color: var(--color-blue);
							}

							&:before{
								content: '';
								position: absolute;
								bottom: 0px;
								left: 0px;
								width: 50px;
								height: 50px;
								color: var(--color-white);
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								font-family: var(--font-family-poppins);
								@include flex(row, center, center);
								background-color: var(--color-red);
							}

							&#tn1:before{
								content: '#1';
							}

							&#tn2:before{
								content: '#2';
							}

							&#tn3:before{
								content: '#3';
							}

							&#tn4:before{
								content: '#4';
							}

							&#tn5:before{
								content: '#5';
							}

							&#tn6:before{
								content: '#6';
							}

							&#tn7:before{
								content: '#7';
							}

							&#tn8:before{
								content: '#8';
							}

							&#tn9:before{
								content: '#9';
							}

							&#tn10:before{
								content: '#10';
							}

							.ticket-overlay{
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								background-color: rgba(255, 255, 255, 0.8);
								z-index: 99;
								@include flex(column, center, center);

								.typed-element{
									.typing{
										font-family: var(--font-family-poppins);
										color: var(--color-blue-dark);
										font-size: 13px;
										text-transform: uppercase;
										font-weight: var(--font-weight-bold);
										margin-top: 5px;
									}
								}
							}

							.nro-ticket{
								position: absolute;
								right: 15px;
								top: 15px;
								padding: 5px 10px;
								border-radius: 99px;
								line-height: 1em;
								letter-spacing: 1px;
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 12px;
								border: 1px dashed var(--color-grey);
							}

							.row{
								width: 100%;
								margin: 7px 0;
								@include flex(row, space-between, center);

								.row-group{
									width: 50%;
									padding: 0px 8px 8px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									span.label{
										font-size: 14px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 17px;
										font-family: var(--font-family-fira);
										@include flex(row, flex-start, center);

										svg{
											margin-left: 5px;
											cursor: pointer;
											width: 14px;
											height: auto;
											margin-top: -1px;

											&:focus{
												outline: none;
											}
										}
									}

									span.campo{
										@include flex(column, center, flex-start);
										font-size: 15px;
										line-height: 22px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 7px;
										padding-bottom: 7px;

										&.campo-small{
											font-family: var(--font-family-poppins);
											color: var(--color-grey);
											font-size: 12px;
											font-weight: 400;
										}
									}

									p{
										margin: 0;
										line-height: 1.3em;
										font-size: 12px;
									}

									input{
										font-size: 15px;
										line-height: 22px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 7px;
										padding-bottom: 7px;

										&:focus{
											border-color: var(--color-blue);
										}

										&:disabled{
											-webkit-text-fill-color: var(--color-grey);
											-webkit-opacity: 1;
											opacity: 1;
											color: var(--color-grey);
										}
									}

									&.row-group-100{
										width: 100%;
									}

									&.row-group-footer{
										width: 100%;
										@include flex(row, flex-start, center);

										input{
											width: auto;
											margin: 0;
											margin-right: 8px;
										}

										label{
											line-height: 1.3em;
											font-size: 12px;
											margin: 0;
										}
									}

									.small-text{
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-grey);
										font-family: var(--font-family-fira);
										font-size: 11px;
										line-height: 1.4em;
										padding: 0px 10px;
									}
								}

								&.row-border-bottom{
									margin-top: 0px;
									border-bottom: 1px dashed #d3d3dc;
									padding-bottom: 14px;

									.row-group{
										width: auto;
									}
								}

								&.row-info{
									margin-top: 0px;
									@include flex(column, center, flex-start);
								}

								span.title{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								&:last-child{
									margin-bottom: 0;
								}

								&.row-aux{
									.ticket-categoria{
										padding: 0px 0px 0px 20px;
										width: auto;
										@include flex(column, center, flex-end);

										span.label{
											font-size: 13px;
											font-weight: var(--font-weight-regular);
											color: var(--color-grey);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 16px;
											font-family: var(--font-family-fira);
										}

										span.campo{
											font-weight: var(--font-weight-bold);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											color: var(--color-dark);
											font-family: var(--font-family-poppins);
											text-transform: uppercase;
											font-size: 13px;

											&.campo-small{
												font-family: var(--font-family-poppins);
												color: var(--color-grey);
												font-size: 12px;
												font-weight: 400;
											}
										}
									}
								}

								.ticket-ubicacion{
									padding-right: 20px;
									border-right: 1px dashed var(--color-grey-medium);
									@include flex(row, flex-start, center);

									.ticket-ubicacion-item{
										padding: 8px 12px 0px 12px;
										// border-right: 1px dashed var(--color-grey-medium);
										border-radius: 0px;
										@include flex(column, flex-start, flex-start);
										// margin-right: 10px;

										&:last-child{
											border-right: none;
										}

										&:first-child{
											padding-left: 0px;
										}

										&:last-child{
											padding-right: 0px;
										}

										.ticket-ubicacion-title{
											font-size: 13px;
											font-weight: var(--font-weight-regular);
											color: var(--color-grey);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 16px;
											font-family: var(--font-family-fira);
										}

										.ticket-ubicacion-valor{
											font-weight: var(--font-weight-bold);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											color: var(--color-dark);
											font-family: var(--font-family-poppins);
											text-transform: uppercase;
											font-size: 13px;
										}
									}
								}

								&.row-complemento{
									flex-wrap: wrap;

									.row-group{
										width: 50%;
										padding-bottom: 15px;

										&:nth-child(2n){
											padding-right: 0px;
										}

										&:nth-child(2n + 1){
											padding-left: 0px;
										}
									}
								}
							}
						}
					}
				}

				.espectaculo-compra-right{
					top: 102px;
					position: sticky;
					margin-top: 86px;
					width: calc(36% - 16px);
					border-radius: 0px;
					padding: 0;
					background-color: var(--color-grey-lighter);

					.resumen-header{
						width: 100%;
						padding: 20px 20px 0 20px;

						h1{
							margin: 0;
							text-transform: uppercase;
							color: var(--color-red);
							font-family: var(--font-family-kapra-bold);
							font-size: 36px;
							-webkit-letter-spacing: -0.3px;
							-moz-letter-spacing: -0.3px;
							-ms-letter-spacing: -0.3px;
							letter-spacing: -0.3px;
							line-height: 1em;
							margin-bottom: 5px;
						}

						p{
							margin: 0;
							color: var(--color-blue-dark);
							font-family: var(--font-family-fira);
							font-weight: var(--font-weight-bold);
							font-size: 16px;
							line-height: 18px;
							margin-bottom: 15px;
						}
					}

					.resumen-listado{
						width: 100%;
						padding: 0 20px;
						margin: 5px 0;
						@include flex(column, flex-start, flex-start);

						.resumen-ticket{
							width: 100%;
							@include flex(row, space-between, center);
							border-bottom: 1px solid #e4e4ef;
							margin: 4px 0px;
							padding: 4px 0 8px 0;

							.resumen-ticket-left{
								@include flex(column, center, flex-start);

								span{
									font-family: var(--font-family-fira);
									font-size: 14px;
									line-height: 21px;
									color: var(--color-grey);

									&.ticket-nro{
										margin: 0;
										font-size: 13px;
										line-height: 20px;
										margin-bottom: 5px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
									}
								}
							}

							.resumen-ticket-right{
								@include flex(column, center, flex-end);

								margin: 0;
								font-size: 15px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}
						}

						.resumen-total{
							width: 100%;
							@include flex(row, space-between, center);
							margin: 5px 0;

							span.label{
								margin: 0;
								font-size: 14px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-red);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							span.total{
								margin: 0;
								font-size: 14px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-red);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}
						}
					}

					.resumen-footer{
						width: 100%;
						padding: 0 20px;
						margin: 5px 0;
						@include flex(column, flex-start, flex-start);

						p{
							margin: 0;
							font-family: var(--font-family-fira);
							font-size: 14px;
							line-height: 21px;
							color: var(--color-dark);
						}
					}

					.acciones-aside{
						padding: 15px 20px 20px 20px;
						width: 100%;
						margin: 0;

						.acciones-aside-botones{
							width: 100%;
							margin: 0;
							@include flex(row, space-between, center);

							button{
								width: 100%;
								@include flex(row, center, center);
								text-transform: uppercase;
								font-family: var(--font-family-poppins);
								font-weight: var(--font-weight-bold);
								position: relative;
								cursor: pointer;
								width: 100%;
								background-color: var(--color-red);
								color: var(--color-white);
								-webkit-transition: background-color .2s ease;
								transition: background-color .2s ease;
								-webkit-letter-spacing: 1px;
								-moz-letter-spacing: 1px;
								-ms-letter-spacing: 1px;
								letter-spacing: 1px;
								padding: 12px 24px;
								font-size: 14px;
								line-height: 20px;
								-webkit-font-smoothing: antialiased;
								-moz-osx-font-smoothing: grayscale;
								outline-color: transparent;
								outline: none;
								box-shadow: none;
								border: 0;
								margin: 0;

								&:hover{
									background-color: var(--color-blue-dark);
								}

								&:disabled{
									color: var(--color-dark);
									background-color: var(--color-grey-light);
									cursor: not-allowed;
								}
							}
						}

						svg, img{
							margin-left: 12px;
							width: 16px;
							height: auto;
						}
					}

					.cancelar-transaccion{
						width: 100%;
						@include flex(row, center, center);
						margin-bottom: 20px;
						font-size: 13px;
						line-height: 20px;
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						color: var(--color-grey);
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
						text-decoration: none;
						transition: all .2s;
						cursor: pointer;

						&:hover{
							color: var(--color-dark);
						}
					}

					.medio-pago{
						width: 100%;
						@include flex(row, center, center);
						margin: 0px;
						background-color: var(--color-white);

						span{
							@include flex(row, center, center);
							font-size: 13px;
							line-height: 1em;
							padding: 15px 0px;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-grey);
							font-family: var(--font-family-fira);
							text-decoration: none;
						}

						img{
							height: 16px;
							width: auto;
							margin-left: 8px;
							margin-top: -1px;
						}
					}
				}

				.mobile-info-title, .full-info-title{
					margin: 0;
					font-size: 18px;
					line-height: 26px;
					font-family: var(--font-family-fira);
					font-weight: bold;
					color: var(--color-dark);
				}

				.mobile-info-title{
					display: none;
				}

				.info-espectaculo{
					border-radius: 8px;
					border: 1px solid #d3d3dc;
					@include flex(column, flex-start, flex-start);

					&.mobile-info-main{
						display: none;
					}
					
					.competencia{
						border-radius: 0px;
						border: none;
						padding: 20px;
						border-bottom: 1px solid #d3d3dc;
						width: 100%;
						@include flex(row, space-between, center);

						.competencia-info{
							@include flex(column, center, flex-start);

							span.competencia-nombre{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 0px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							span.competencia-instancia{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}

						img{
							height: 32px;
							width: auto;
							margin-left: 15px;
						}
					}

					.fecha{
						border-radius: 0px;
						border: none;
						padding: 20px;
						border-bottom: 1px solid #d3d3dc;
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.fecha-title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}

						.fecha-content{
							width: 100%;
							@include flex(row, space-between, center);

							.fecha-texto{
								@include flex(column, center, flex-start);

								p{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
									margin: 0;
								}
							}

							.fecha-hora{
								height: 100%;
								margin-left: 14px;
								border-left: 1px solid #d3d3dc;
								padding: 10px 0 10px 14px;
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 21px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}

					.lugar{
						border-radius: 0px;
						border: none;
						padding: 20px;
						border-bottom: 1px solid #d3d3dc;
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.lugar-title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}

						.lugar-content{
							@include flex(row, space-between, center);
							width: 100%;

							.lugar-content-left{
								@include flex(row, flex-start, center);

								.lugar-info{
									padding-right: 12px;
									// border-right: 1px solid #d3d3dc;
									@include flex(column, center, flex-start);

									span.lugar-escenario{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
									}

									span.lugar-direccion{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 13px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 18px;
									}
								}

								img{
									width: 28px;
									height: auto;
									margin-left: 12px;
								}
							}

							.ver-mapa{
								@include flex(column, center, center);
								margin-left: 12px;

								a{
									background-color: transparent;
									border: 1px solid var(--color-blue-darker);
									padding: 6px;
									text-decoration: none;
									@include flex(row, center, center);
									transition: all .2s;
									border-radius: 99px;

									svg{
										width: 15px;
										height: auto;
										transition: all .2s;
										color: var(--color-blue-darker);
									}

									&:hover{
										background-color: var(--color-blue-darker);

										svg{
											color: var(--color-white);
										}
									}
								}
							}
						}
					}

					.descripcion{
						border-radius: 0px;
						border: none;
						padding: 20px;
						width: 100%;
						@include flex(column, flex-start, flex-start);
						
						.descripcion-title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}

						.descripcion-content{
							color: var(--color-dark);
							font-family: var(--font-family-fira);
							font-weight: var(--font-weight-regular);
							font-size: 15px;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							line-height: 20px;
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 910px){
		.espectaculo-compra-page{
			.espectaculo-compra-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.espectaculo-compra-main{
				margin: 30px 0;

				.container{
					@include flex(column, flex-start, flex-start);

					.espectaculo-compra-left{
						width: 100%;

						.full-info-title, .full-info-main{
							display: none;
						}

						p{
							font-size: 16px;
						}

						h1{
							font-size: 29px;
							line-height: 23px;
						}

						.tickets{
							.ticket{
								.nro-ticket{
									border: none;
									padding: 0;
									line-height: 20px;
								}
							}
						}
					}

					.mobile-info-title{
						display: block;
						margin-top: 20px;
						font-size: 16px;
					}
					
					.info-espectaculo{
						&.mobile-info-main{
							@include flex(column, flex-start, flex-start);
						}
					}

					.espectaculo-compra-right{
						margin-top: 0px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 730px){
		.espectaculo-compra-page{
			.espectaculo-compra-header{
				.container{
					.contador{
						background-color: var(--color-blue-light);
						@include flex(row, space-between, center);
						position: fixed;
						width: 100%;
						bottom: 0px;
						left: 0;
						height: 40px;
						border: none;

						.tiempo-restante-label{
							color: var(--color-dark);
						}

						.tiempo-restante{
							color: var(--color-dark);
							font-size: 15px;
						}
					}
				}
			}
		}
	}


	@media screen and(max-width: 590px){
		.espectaculo-compra-page{
			.espectaculo-compra-main{
				.container{
					 .espectaculo-compra-left{
						  .tickets{
							   .ticket{
								   padding-left: 60px;

								    .row{
										@include flex(column, flex-start, flex-start);

										.row-group{
											width: 100%;
											padding: 0px;
											padding-bottom: 5px;

											span.label{
												font-size: 14px;
												line-height: 17px;
											}

											span.campo{
												font-size: 14px;
												line-height: 20px;
											}

											input{
												font-size: 14px;
												line-height: 20px;
											}

											.small-text{
												display: none;
											}
										}

										&.row-aux{
											.ticket-ubicacion{
												width: 100%;
												flex-wrap: wrap;
												padding-right: 0px;
												border-right: none;
												padding-bottom: 10px;

												.ticket-ubicacion-item{
													border-right: none;
													padding: 10px 8px 5px 8px;

													&:first-child{
														padding-left: 0px;
													}
												}
											}

											.ticket-categoria{
												padding: 0px;
												@include flex(column, center, flex-start);
											}
										}

										&.row-complemento{
											.row-group{
												width: 100%;
											}
										}
									}

									&:after{
										width: 40px;
										height: calc(100% - 40px);
									}

									&:before{
										width: 40px;
										height: 40px;
										font-size: 13px;
									}
							   }
						  }
					 }
				}
			}
		}
	}

	@media screen and(max-width: 490px){
		.espectaculo-compra-page{
			.espectaculo-compra-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}

























	

// @media screen and (max-width: 530px){
// 	.prompt-pago-content{
// 		margin: 20px !important;
// 	}

// 	.card-form{
// 		&__inner{
// 			box-shadow: none !important;
// 			-webkit-box-shadow: none !important;
// 		}
// 	}
// }

// 	/* Responsive */
// 	@media screen and (max-width: 1308px) {
// 		.espectaculo-compra{
// 			.espectaculo-header{
// 				.container{
// 					padding-left: 24px;
// 					padding-right: 24px;
// 					@include flex(row, flex-start, center);
// 				}
// 			}

// 			.espectaculo-main{
// 				.container{
// 					padding-left: 24px;
// 					padding-right: 24px;
// 				}
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 1240px) {
// 		.espectaculo-compra{
// 			.espectaculo-header{
// 				.container{
// 					flex-wrap: wrap;
// 					@include flex(row, space-around, center);
// 				}
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 1140px) {
// 		.espectaculo-compra{
// 			.espectaculo-main{
// 				.container{
// 					.espectaculo-content{
// 						.espectaculo-content-row{
// 							@include flex(column, center, center);

// 							.ticket{
// 								width: 80%;
// 							}
// 						}
// 					}
// 				}
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 940px) {
// 		.espectaculo-compra{
// 			.espectaculo-main{
// 				.container{
// 					.espectaculo-content{
// 						.espectaculo-content-row{
// 							.ticket{
// 								width: 100%;
// 							}
// 						}
// 					}
// 				}
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 840px) {
// 		.espectaculo-compra{
// 			.espectaculo-main{
// 				.container{
// 					@include flex(column, center, center);
// 					.espectaculo-content{
// 						width: 100%;
// 						margin: 0;
// 						margin-bottom: 20px;

// 						.espectaculo-content-row{
// 							@include flex(row, space-between, center);

// 							.ticket{
// 								width: calc(50% - 10px);
// 							}
// 						}
// 					}

// 					aside{
// 						width: 100%;
// 						margin: 0;
// 						position: relative;
// 						top: auto;
// 					}
// 				}
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 740px) {
// 		.espectaculo-compra{
// 			.espectaculo-main{
// 				.container{
// 					.espectaculo-content{
// 						.espectaculo-content-row{
// 							@include flex(column, center, center);

// 							.ticket{
// 								width:100%;
								
// 								.row{
// 									.row-group{
// 										width: calc(50% - 5px);

// 										&.row-group-100{
// 											width: 100%;
// 										}
// 									}
// 								}
// 							}
// 						}
// 					}
// 				}
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 670px) {
// 		.espectaculo-compra{
// 			.espectaculo-header{
// 				.container{
// 					@include flex(column, center, center);
					
// 					.header-equipos{
// 						margin: 5px 0;

// 						.header-equipo.header-equipo-local .header-escudo, .header-equipo.header-equipo-visitante .header-escudo{
// 							height: 24px;
// 						}

// 						.header-equipo.header-equipo-local span, .header-equipo.header-equipo-visitante span{
// 							font-size: 20px;
// 						}

// 						.header-equipo.header-equipo-local span.vs{
// 							font-size: 13px;
// 						}
// 					}

// 					.competencia{
// 						margin: 5px 0;
// 					}

// 					.fecha{
// 						margin: 5px 0;
// 					}

// 					.lugar{
// 						margin: 5px 0;
// 					}

// 					.contador{
// 						margin: 5px 0;
// 					}
// 				}
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 480px) {
// 		.card-form__inner .tarjetas-disponibles{
// 			flex-wrap: wrap;
// 			.tarjeta{
// 				margin: 5px;
// 			}
// 		}
// 	}

// 	@media screen and (max-width: 450px) {
// 		.espectaculo-compra{
// 			.espectaculo-main{
// 				.container{
// 					aside{
// 						.acciones-aside{
// 							.acciones-aside-botones{
// 								@include flex(column, flex-start, flex-start);

// 								button{
// 									width: 100%;
// 									margin: 0;
// 									margin: 5px 0;
// 									order: 1;

// 									&.cancelar-reserva{
// 										width: 100%;
// 										margin: 0;
// 										margin: 5px 0;
// 										order: 2;
// 									}
// 								}
// 							}
// 						}
// 					}
// 				}
// 			}
// 		}
// 	}
</style>